/**
 * Custom filters — JSON index with Bonprix parity (rules + Maximize-like UI).
 * Isolated from Maximize S&D facets.js.
 */
(function () {
    const CORE_KEYS = new Set([
      'id',
      'handle',
      'title',
      'url',
      'vendor',
      'productType',
      'condition',
      'price',
      'compareAt',
      'compare_at',
      'available',
      'image',
      'imageHover',
      'image_hover',
      'collections',
      'createdAt',
      'created_at',
      'sales',
    ]);
  
    // Brand bar covers vendor; Condition bar covers condition.
    // product_brand y product_status son las claves B2 para lo mismo: la barra de logos ya
    // cubre marca (vendor) y la barra de condicion cubre condicion (condition, presente en
    // los 2142 productos frente a 1199 de product_status). Se ocultan para no duplicar el
    // filtro en el panel lateral. Ver tareas u2UEbAkYPIeISWeJ87mS y mPQVXzboLM1CFRy8fSGt.
    const ASIDE_HIDDEN_KEYS = new Set(['condition', 'vendor', 'product_brand', 'product_status']);

    // Facetas numericas que se pintan como Range Slider en vez de lista de checkboxes.
    // Fuente preferida: el propio indice, marcando la faceta con "type": "range" (y
    // opcionalmente "unit" y "step") en su array `facets`. Este mapa es el fallback para
    // los indices que todavia no lo traen; cuando el indice lo declare, sobra la entrada.
    const RANGE_FACETS = {
      // Respaldo por si el indice no declara la unidad. «in», no «inch(es)»: el
      // parentesis del plural venia del dato de origen y salia en el titulo de la
      // faceta y en el chip. El indice manda; esto solo actua si no viene.
      class_width: { unit: 'in', step: 1 },
    };

    // Version del esquema del indice que entiende este JS (data.version, no la v2 de
    // facets.i18n.json). Si el indice cambia de forma, esto avisa en vez de fallar callando.
    const SCHEMA_INDICE_SOPORTADO = 1;

    // A partir de cuantos dias se avisa de que el indice esta viejo. El refresh se lanza a
    // mano, asi que este es el unico canario mientras no haya cron.
    const DIAS_INDICE_VIEJO = 7;

    // Devuelve la config de rango de una faceta, o null si no es de rango.
    function facetRangeMeta(meta, key) {
      const f = meta && meta.byKey ? meta.byKey.get(key) : null;
      if (f && f.type === 'range') {
        return { unit: f.unit || '', step: Number(f.step) > 0 ? Number(f.step) : 1 };
      }
      return RANGE_FACETS[key] || null;
    }

    // Primer numero del valor, sin unidad. Resuelve de paso las variantes sucias del
    // indice: "30 inch(eS)" -> 30, "25,04 inch(es)" -> 25.04 y los compuestos
    // "Washer 28 inch(es) / Dryer 27 inch(es)" -> 28 (se toma la lavadora).
    function facetNumber(raw) {
      if (raw == null) return null;
      const m = String(raw).match(/-?\d+(?:[.,]\d+)?/);
      if (!m) return null;
      const n = Number(m[0].replace(',', '.'));
      return Number.isFinite(n) ? n : null;
    }

    // Rango activo? (null en un extremo = sin limite por ese lado)
    function rangeIsActive(r) {
      return !!r && (r.min != null || r.max != null);
    }

    // Valores que no son un valor: el indice deja pasar restos de la sincronizacion
    // ("N/", "N /" en number_of_temperature_settings y class_width) y se pintaban como
    // opcion marcable con su contador. Se comparan sin espacios, asi que "N / A" y "N/A"
    // caen en la misma entrada. La limpieza en origen es la tarea CF05; esta es la defensa
    // del tema, que protege de cualquier placeholder futuro sin esperar a un rebuild.
    const PLACEHOLDER_VALUES = new Set(['n/a', 'na', 'n/', 'n.a.', 'nc', 'none', 'null', '-', '--']);

    // Recibe el valor ya recortado. El atajo por longitud no es cosmetico: esta funcion corre
    // dentro del bucle de conteo, decenas de miles de veces por render, y sin el se normalizaba
    // "Stainless Steel" (1008 productos) para nada. Ningun placeholder pasa de 6 caracteres, asi
    // que el 68% de los valores del indice se descartan con una comparacion de numeros.
    function isPlaceholderValue(s) {
      if (s.length > 6) return false;
      return PLACEHOLDER_VALUES.has(s.toLowerCase().replace(/\s+/g, ''));
    }

    // Lista de valores reales de una faceta. Tolerante y compatible hacia adelante: acepta
    // array real, string que contiene un array JSON ('["Laval","Montreal"]') y escalar, asi
    // que sigue funcionando cuando Polaris normalice el indice. Un escalar simple devuelve
    // una lista de un elemento; ausencia de valor, lista vacia.
    //
    // El descarte de placeholders vive AQUI y no en countsForKey porque este es el unico
    // punto por el que pasan los dos consumidores: el conteo de la faceta y matchesFilters.
    // Filtrar solo en el conteo dejaria valores que se cuentan como ausentes pero siguen
    // filtrando.
    function facetValues(raw) {
      if (raw == null || raw === '') return [];
      // Un solo recorrido en vez de map + filter: evita el array intermedio en un camino que
      // se ejecuta una vez por producto y por faceta.
      const limpiar = (list) => {
        const out = [];
        for (const x of list) {
          const s = String(x).trim();
          if (s && !isPlaceholderValue(s)) out.push(s);
        }
        return out;
      };
      if (Array.isArray(raw)) return limpiar(raw);
      const s = String(raw).trim();
      if (s.charAt(0) === '[') {
        try {
          const arr = JSON.parse(s);
          if (Array.isArray(arr)) return limpiar(arr);
        } catch (e) {
          /* no era JSON valido: se trata como escalar */
        }
      }
      return limpiar([s]);
    }
  
    // facetValues() para un producto, memoizado en el propio producto. El parseo (JSON.parse de
    // location y product_status, trim y descarte de placeholders) se hacia dentro del bucle de
    // conteo: del orden de 47.000 veces por render, siempre con el mismo resultado. Se guarda
    // perezosamente, asi que solo se calcula para las claves que se usan de verdad.
    // El campo __cfv es un objeto, y searchableText ya descarta los valores de tipo object.
    function facetValuesOf(p, key) {
      const cache = p.__cfv || (p.__cfv = {});
      let vals = cache[key];
      if (vals === undefined) {
        vals = facetValues(p[key]);
        cache[key] = vals;
      }
      return vals;
    }

    function qs(root, sel) {
      return root.querySelector(sel);
    }
  
    function normalizeLabel(s) {
      return String(s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '')
        .trim();
    }
  
    function handleize(s) {
      return String(s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    }
  
    function labelize(key) {
      return String(key)
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, (c) => c.toUpperCase());
    }
  
    function escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  
    function escapeAttr(s) {
      return escapeHtml(s).replace(/'/g, '&#39;');
    }
  
    function parseLines(text) {
      return String(text || '')
        .split(/\r?\n|;|,/)
        .map((l) => l.trim())
        .filter(Boolean);
    }
  
    function parsePriorityRules(text) {
      return parseLines(text)
        .map((line) => {
          const parts = line.split('|');
          if (parts.length < 2) return null;
          return {
            handle: parts[0].trim().toLowerCase(),
            filter: parts.slice(1).join('|').trim(),
          };
        })
        .filter(Boolean);
    }
  
    function buildFacetMeta(data) {
      const configured = Array.isArray(data.facets) ? data.facets.slice() : [];
      configured.sort((a, b) => (a.order || 0) - (b.order || 0));
      const byKey = new Map(configured.map((f) => [f.key, f]));
      // Only paint facets declared in the index config (S&D allowlist).
      // Price is rendered by the dedicated slider block, not as checkbox values.
      const ordered = configured
        .map((f) => f.key)
        .filter((key) => key !== 'price' && byKey.get(key)?.type !== 'price');
      return { orderedKeys: ordered, byKey };
    }
  
    function displayValue(meta, key, raw) {
      const f = meta.byKey.get(key);
      const map = f && f.valueLabels;
      if (map && raw != null && map[String(raw)]) return map[String(raw)];
      return String(raw);
    }
  
    function displayLabel(meta, key) {
      const f = meta.byKey.get(key);
      if (f && f.label) return f.label;
      return labelize(key);
    }
  
    function facetMatchesName(meta, key, name) {
      const n = normalizeLabel(name);
      if (!n) return false;
      if (normalizeLabel(key) === n) return true;
      if (normalizeLabel(displayLabel(meta, key)) === n) return true;
      if (normalizeLabel(labelize(key)) === n) return true;
      return false;
    }
  
    function applyFacetOrderRules(meta, keys, collectionHandle, priorityRules, hiddenRules) {
      const handle = String(collectionHandle || '').toLowerCase();
      const pinNames = [];
      const hideNames = [];
  
      for (const rule of priorityRules) {
        if (rule.handle === handle) pinNames.push(rule.filter);
        else hideNames.push(rule.filter);
      }
      for (const rule of hiddenRules) {
        if (rule.handle === handle) hideNames.push(rule.filter);
      }

      // Una regla con el JSON bien escrito pero que nombra una faceta que NO EXISTE no hace
      // nada, y hasta ahora tampoco avisaba: la faceta que se queria ocultar seguia saliendo.
      // CF26 cubrio el JSON invalido; esto cubre la errata DENTRO de un JSON valido, que es
      // mas facil de cometer porque las reglas se escriben a mano, una por linea, en un campo
      // de texto de los ajustes. facetMatchesName ya es tolerante (clave, etiqueta localizada
      // y clave "labelizada"), asi que si no casa con ninguna de las tres, es una errata.
      const reglasSinPareja = [...new Set([...pinNames, ...hideNames])].filter(
        (name) => !keys.some((k) => facetMatchesName(meta, k, name)),
      );
      if (reglasSinPareja.length) {
        console.warn(
          '[custom-filters] reglas de hide/pin que no casan con ninguna faceta y se ignoran:',
          reglasSinPareja.join(' | '),
        );
      }

      const hideKeys = new Set(
        keys.filter((k) => hideNames.some((name) => facetMatchesName(meta, k, name))),
      );
      const pinKeys = keys.filter(
        (k) => !hideKeys.has(k) && pinNames.some((name) => facetMatchesName(meta, k, name)),
      );
      const rest = keys.filter((k) => !hideKeys.has(k) && !pinKeys.includes(k));
      return [...pinKeys, ...rest];
    }
  
    function rangeSortKey(raw) {
      const s = String(raw || '').trim();
      const lower = s.toLowerCase();
      if (/^(below|sous|under|moins|inferior|inférieur)\b/i.test(lower)) {
        return { bucket: 0, num: -Infinity };
      }
      if (/^(above|over|plus|au[- ]?dessus|superior|supérieur)\b/i.test(lower)) {
        return { bucket: 2, num: Infinity };
      }
      const normalized = s.replace(/,/g, '');
      const m = normalized.match(/-?\d+(?:\.\d+)?/);
      const num = m ? Number(m[0]) : Number.NaN;
      if (!Number.isNaN(num)) return { bucket: 1, num };
      return { bucket: 1, num: Number.POSITIVE_INFINITY };
    }
  
    function shouldUseRangeSort(meta, key, values) {
      const mode = meta.byKey.get(key)?.valueSort;
      if (mode === 'range' || mode === 'numeric_range') return true;
      if (mode === 'alpha') return false;
      return values.some((v) =>
        /^(below|above|sous|under|over|plus|au[- ]?dessus)\b/i.test(String(v).trim()),
      );
    }
  
    function compareFacetValues(meta, key, a, b, useRange) {
      if (useRange) {
        const ka = rangeSortKey(a);
        const kb = rangeSortKey(b);
        if (ka.bucket !== kb.bucket) return ka.bucket - kb.bucket;
        if (ka.num !== kb.num) return ka.num - kb.num;
      }
      return displayValue(meta, key, a).localeCompare(displayValue(meta, key, b), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }
  
    function productInCollection(p, handle) {
      if (!handle) return true;
      if (String(handle).toLowerCase() === 'all') return true;
      const list = p.collections || [];
      return list
        .map(String)
        .map((h) => h.toLowerCase())
        .includes(handle.toLowerCase());
    }
  
    // Se reconstruia entero en cada llamada de matchesSearch -por producto y por render-, y
    // concatena hasta 30 handles de coleccion mas todos los campos no core. Solo se paga en
    // /search, pero ahi se paga en cada interaccion. El resultado no cambia nunca, asi que se
    // memoiza en el propio producto, igual que facetValuesOf.
    // Colecciones que cubren mas de la mitad del catalogo: no dicen nada del producto y
    // ensucian la busqueda. Medido el 28-sep-2026 sobre el indice vivo son 12 de 395 y son
    // todas fontaneria interna -all, price-not-0, productos-debe-estar-ok, stock-more-than-0,
    // top-selling-products, globofilter-best-selling-products-index, from-500-to-2000,
    // 0-or-more, new_title_updated, all-products-new-telque, 10-20-days-appliances y
    // black-friday-. Con ellas dentro, buscar 'black friday' devolvia 1.443 de 2.310
    // productos, o sea el 62 % de la tienda.
    //
    // NO se quitan TODOS los handles, que era la otra opcion: 'laundry' pasaria de 341
    // resultados a 90 y 'washer' de 332 a 273, porque ahi el handle es la unica pista (un
    // secador no dice 'laundry' en el titulo ni en el tipo). Con el tope, de doce consultas
    // medidas la unica que cambia es 'black friday'.
    //
    // El umbral se recalcula con cada indice, asi que una coleccion que encoja vuelve sola
    // y una nueva que se infle se va sola. No hay lista que mantener.
    const TOPE_HANDLE_GENERICO = 0.5;

    // Por debajo de esto una faceta no se pinta en esa coleccion: conoce a tan poca
    // gente que marcarla esconde casi todo sin avisar. El caso mas ridiculo medido el
    // 28-sep-2026 era washer_capacity en la coleccion de precio '1251-1750', con el dato
    // en 2 productos de 187.
    // De los 3.761 pares faceta x coleccion que se pintaban, el 25 % esconde 841 (el
    // 22 %) y no toca ni uno de los emparejamientos buenos, que van al 100 %: steam en
    // open-box-dryers 67/67, number_of_burners en open-box-ranges 54/54,
    // features_hard_food en open-box-dishwasers 18/18.
    const TOPE_COBERTURA_FACETA = 0.25;
    let handlesGenericos = new Set();

    // Colecciones cuyo nombre dice lo CONTRARIO de lo que contiene. Medido el 20-oct-2026:
    // por 'product-title-not-open-box-or-new' (928 tel quel) buscar «open box» devolvia la
    // tienda entera, 2.113 de 2.113, y «new» 1.380. Y por 'no-promo' (87), «promo»
    // encontraba justo lo que no esta en promocion.
    const HANDLE_NEGADO = /(^|-)(not|no)(-|$)/;

    // Las facetas del indice tambien se buscan, con la etiqueta que ve el cliente. Sin eso:
    // - el indice frances guarda los valores EN INGLES (la traduccion va aparte, en
    //   valueLabels), asi que se buscaba «Freestanding» y no «Pose libre»; «autonettoyant»
    //   daba 2 productos y «machine à glaçons» 14, frente a 169 y 235;
    // - una faceta Si/No solo aporta «Yes», asi que «wifi» daba CERO con 401 productos que
    //   lo tienen, y «counter depth refrigerator» 1 frente a 81.
    // Se rellena en pintarIndice, antes de la primera busqueda.
    let facetasBusqueda = [];
    // Ubicacion y estado no describen el producto: con ellas «laval» casaria con media tienda.
    const FACETAS_FUERA_DE_BUSQUEDA = new Set(['price', 'location', 'product_status']);
    // Su etiqueta nombra otro electrodomestico: «Dishwasher-safe filters» metia 23 campanas
    // en «washer» y en «dishwasher». Se busca por su clave («washable filters»).
    const ETIQUETA_ENGANOSA = new Set(['spec_washable_filters']);

    function calcularHandlesGenericos(productos) {
      const n = productos.length;
      if (!n) return new Set();
      const cuenta = new Map();
      for (const p of productos) {
        for (const c of p.collections || []) cuenta.set(c, (cuenta.get(c) || 0) + 1);
      }
      const fuera = new Set();
      for (const [c, k] of cuenta) if (k > TOPE_HANDLE_GENERICO * n) fuera.add(c);
      return fuera;
    }

    /**
     * Quita los acentos para poder comparar. «cuisiniere» tiene que encontrar
     * «cuisinière»: medido sobre el indice frances, escribir sin tilde devolvia 68
     * productos y con tilde 420, o sea que se perdian 352. Y «refrigerateur» perdia 258.
     *
     * Se aplica A LAS DOS PARTES -al texto del producto y a lo que escribe el cliente- y
     * tiene que seguir siendo asi: plegar solo una de las dos no arregla nada.
     */
    function sinAcentos(s) {
      return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function searchableText(p) {
      if (p.__cfs !== undefined) return p.__cfs;
      const cols = (p.collections || []).filter((c) => !handlesGenericos.has(c) && !HANDLE_NEGADO.test(c));
      const parts = [p.title, p.handle, p.vendor, p.productType, p.condition, ...cols];
      for (const [k, v] of Object.entries(p)) {
        if (CORE_KEYS.has(k) || k.indexOf('__cf') === 0 || v == null || typeof v === 'object') continue;
        parts.push(String(v));
      }
      parts.push(...etiquetasDeBusqueda(p));
      p.__cfs = sinAcentos(parts.join(' ')).toLowerCase();
      return p.__cfs;
    }

    function etiquetasDeBusqueda(p) {
      const out = [];
      for (const f of facetasBusqueda) {
        const v = p[f.key];
        if (v == null) continue;
        for (const x of Array.isArray(v) ? v : [v]) {
          if (x === 'Yes') {
            // El nombre de la faceta, en el idioma de la tienda y como clave sin prefijo:
            // «Wi-Fi» no casa con «wifi», pero 'features_wifi' si.
            if (!ETIQUETA_ENGANOSA.has(f.key)) out.push(f.label || '');
            out.push(f.key.replace(/^(filters_features_|filters_|features_|spec_)/, '').replace(/_/g, ' '));
          } else if (x !== 'No' && x !== 'Optional') {
            out.push((f.valueLabels && f.valueLabels[x]) || String(x));
          }
        }
      }
      return out;
    }
  
    /**
     * Sinonimos de la busqueda. El buscador compara subcadenas contra el texto del
     * producto, asi que una palabra que no este escrita ahi no encuentra nada por mucho
     * que la tienda venda justo eso.
     *
     * MEDIDO: «stove» devolvia CERO con 381 cuisinieres en catalogo, porque ningun titulo
     * lleva esa palabra. El buscador nativo de Shopify si lo resolvia. Ver [Filtros 80].
     *
     * EL SINONIMO SE COMPARA CONTRA EL TIPO DE PRODUCTO, NO CONTRA TODO EL TEXTO, y esa
     * es la decision importante. El primer intento buscaba la palabra en todo el texto y
     * «stove» -> «range» arrastraba 683 productos: 128 campanas («Range Hoods»), 62
     * microondas («Over-The-Range») y 80 Kitchen Bundles. Comparando contra el tipo salen
     * 400 y todos son cuisinieres de verdad.
     *
     * SE ESCRIBE SIN ACENTOS A PROPOSITO: el texto ya pasa por sinAcentos antes de
     * comparar, asi que «poele» cubre tambien «poêle».
     *
     * ES UNA LISTA A MANO Y ESA ES SU PEGA. Se queda corta a proposito -solo lo que se ha
     * visto fallar- en vez de inventar un diccionario que nadie va a revisar.
     */
    const SINONIMOS = {
      stove: ['range'],
      poele: ['range'],
      cuisiniere: ['range'],
      oven: ['oven', 'range'],
      four: ['oven', 'range'],
      fridge: ['refrigerator', 'refrigerateur'],
      refrigerateur: ['refrigerator'],
      frigo: ['refrigerator', 'refrigerateur'],
      hood: ['ventilation', 'hotte'],
      hotte: ['ventilation'],
      washer: ['washer', 'laveuse'],
      laveuse: ['washer'],
      dryer: ['dryer', 'secheuse'],
      secheuse: ['dryer'],
      freezer: ['freezer', 'congelateur'],
      congelateur: ['freezer'],
      dishwasher: ['dishwasher', 'lave-vaisselle'],
      lavevaisselle: ['dishwasher'],
      // Las faltas que mas se escriben: «refridgerator» daba CERO.
      refridgerator: ['refrigerator'],
      refrigirator: ['refrigerator'],
      washing: ['washer'],
    };

    // Frases que se reescriben antes de partir la consulta, porque palabra a palabra no
    // casan: «washing machine» exigia «machine», «mini fridge» exigia «mini», y «as is» y
    // «égratigné» son como se dice tel quel. Todas daban CERO. Mismo criterio que los
    // sinonimos: solo lo que se ha visto fallar.
    const FRASES = [
      ['dish washer', 'dishwasher'],
      ['frontale', 'frontal'],
      ['washing machine', 'washer'],
      ['machine a laver', 'laveuse'],
      ['mini fridge', 'compact fridge'],
      ['mini frigo', 'compact frigo'],
      ['mini-frigo', 'compact frigo'],
      ['wine fridge', 'wine'],
      ['stackable washer dryer', 'stacked washer dryer'],
      ['as is', 'telquel'],
      ['egratigne', 'telquel'],
      ['sur pied', 'pose libre'],
    ];

    // Se exigen todas las palabras, asi que una de enlace que no este en la ficha lo
    // tumbaba todo: «réfrigérateur avec machine à glaçons» daba 7 y sin el «avec» 208.
    const PALABRAS_VACIAS = new Set([
      'and', 'with', 'for', 'the', 'an', 'of',
      'de', 'du', 'des', 'la', 'le', 'les', 'et', 'a', 'au', 'aux', 'avec', 'pour', 'en', 'un', 'une',
    ]);

    function esLetraODigito(c) {
      return c !== undefined && /[a-z0-9]/.test(c);
    }

    // Si t aparece al principio de una palabra del texto (o como palabra entera).
    function apareceComoPalabra(t, texto, entera) {
      for (let i = texto.indexOf(t); i !== -1; i = texto.indexOf(t, i + 1)) {
        if (!esLetraODigito(texto[i - 1]) && (!entera || !esLetraODigito(texto[i + t.length]))) return true;
      }
      return false;
    }

    function esDelTipo(t, tipo) {
      const alt = SINONIMOS[t];
      return apareceComoPalabra(t, tipo, false) || (!!alt && alt.some((a) => apareceComoPalabra(sinAcentos(a), tipo, false)));
    }

    function casaPalabra(t, hay, tipo) {
      // Las palabras de categoria tienen que EMPEZAR palabra: «washer» va dentro de
      // «dishwasher», y «washer» y «laveuse» traian 122 y 95 lavavajillas.
      if (SINONIMOS[t]) return apareceComoPalabra(t, hay, false) || esDelTipo(t, tipo);
      // Dos letras o menos, palabra entera: «ge» va dentro de «range» y de «fridge», y
      // buscar la marca GE devolvia 1.795 productos (la nativa da 233). Tambien «lg» en
      // «Fulgor» y «36» en «LF25S6200S» con «36 inch refrigerator».
      // Con letras basta con EMPEZAR palabra (un titulo pegado y cortado acaba en «…ENERGY
      // ST»); con cifras tiene que ser el numero entero: «36» como prefijo metia 109 neveras
      // que no son de 36 pulgadas («36.5», «3600»).
      return t.length <= 2 ? apareceComoPalabra(t, hay, /^[0-9]+$/.test(t)) : hay.includes(t);
    }

    function palabrasDeConsulta(query) {
      let q = ' ' + sinAcentos(query || '').trim().toLowerCase().replace(/\s+/g, ' ') + ' ';
      for (const [frase, cambio] of FRASES) q = q.split(' ' + frase + ' ').join(' ' + cambio + ' ');
      const tokens = q.split(' ').filter(Boolean);
      const llenas = tokens.filter((t) => !PALABRAS_VACIAS.has(t));
      return llenas.length ? llenas : tokens;
    }

    /**
     * Faltas de ortografia ([Filtros 90]). La lista de SINONIMOS solo arregla las que se
     * han visto: «dishwaser», «refigerator», «samsong» o «whirpool» daban CERO.
     *
     * SOLO SE TOCA UNA PALABRA QUE NO CASA CON NINGUN PRODUCTO DEL INDICE, asi que nunca
     * empeora una busqueda que ya encontraba algo. Se cambia por la palabra del catalogo mas
     * parecida: una letra de diferencia si tiene de 5 a 7, dos si tiene 8 o mas. Con menos
     * de 5 letras o si son cifras (un SKU) no se toca: con tan poco, «wolf» o «gaz» se
     * convertirian en cualquier cosa. A igualdad de parecido gana la palabra mas frecuente.
     *
     * Las marcas que no se venden se quedan en cero, y es lo correcto: «miele» esta a tres
     * letras de «midea» y «speed» a dos de «steel».
     */
    let vocabulario = null;

    function vocabularioDe(productos) {
      if (vocabulario) return vocabulario;
      vocabulario = new Map();
      for (const p of productos) {
        for (const w of searchableText(p).split(/[^a-z0-9]+/)) {
          if (w.length >= 4) vocabulario.set(w, (vocabulario.get(w) || 0) + 1);
        }
      }
      for (const k of Object.keys(SINONIMOS)) vocabulario.set(k, (vocabulario.get(k) || 0) + 1000);
      return vocabulario;
    }

    // Distancia de edicion con trasposicion (Damerau, version OSA). Corta en cuanto pasa del tope.
    function distancia(a, b, tope) {
      if (Math.abs(a.length - b.length) > tope) return tope + 1;
      let antes = null;
      let fila = Array.from({ length: b.length + 1 }, (_, j) => j);
      for (let i = 1; i <= a.length; i++) {
        const nueva = [i];
        let minimo = i;
        for (let j = 1; j <= b.length; j++) {
          let v = Math.min(fila[j] + 1, nueva[j - 1] + 1, fila[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          if (antes && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, antes[j - 2] + 1);
          nueva.push(v);
          if (v < minimo) minimo = v;
        }
        if (minimo > tope) return tope + 1;
        antes = fila;
        fila = nueva;
      }
      return fila[b.length];
    }

    function corregirPalabras(productos, tokens) {
      const cambios = [];
      const out = tokens.map((t) => {
        if (t.length < 5 || /^\d+$/.test(t)) return t;
        const casaAlguno = productos.some((p) => {
          const tipo = sinAcentos(p.productType || '').toLowerCase();
          return casaPalabra(t, searchableText(p), tipo) || (t.endsWith('s') && esDelTipo(t.slice(0, -1), tipo));
        });
        if (casaAlguno) return t;
        const tope = t.length >= 8 ? 2 : 1;
        let mejor = null;
        let mejorD = tope + 1;
        let mejorN = 0;
        for (const [w, n] of vocabularioDe(productos)) {
          const d = distancia(t, w, tope);
          if (d < mejorD || (d === mejorD && n > mejorN)) {
            mejor = w;
            mejorD = d;
            mejorN = n;
          }
        }
        if (!mejor || mejorD > tope) return t;
        cambios.push([t, mejor]);
        return mejor;
      });
      return { tokens: out, cambios };
    }

    function matchesSearch(p, query) {
      return casaConPalabras(p, palabrasDeConsulta(query));
    }

    function casaConPalabras(p, tokens) {
      if (!tokens.length) return true;
      const hay = searchableText(p);
      const tipo = sinAcentos(p.productType || '').toLowerCase();
      // Siguen haciendo falta TODAS las palabras, pero cada una vale por si misma O porque
      // el TIPO del producto responde a su sinonimo. Asi «stove» encuentra las cuisinieres
      // sin que «stove inox» deje de exigir tambien «inox».
      //
      // EL PLURAL se prueba en singular, y SOLO contra el tipo: «fridges», «stoves» y
      // «frigos» daban CERO, y «cuisinières» 195 de 483. Contra todo el texto, «ranges»
      // arrastraba 293 campanas («Range Hoods»).
      return tokens.every(
        (t) => casaPalabra(t, hay, tipo) || (t.length > 3 && t.endsWith('s') && esDelTipo(t.slice(0, -1), tipo))
      );
    }

    /**
     * Orden de una busqueda ([Filtros 89]). Antes salia el orden de la coleccion: buscar un
     * modelo no lo ponia primero, y en «refrigerator» los kits y paquetes que solo casaban
     * por una coleccion o una faceta salian mezclados con las neveras.
     *
     * Por cada palabra: modelo o SKU exacto (100), modelo que empieza por ella (50), el tipo
     * de producto que responde a ella (10) y la palabra en el titulo (5). El tipo pesa mas
     * que el titulo porque «fridge» no sale en el titulo de ninguna nevera («REFRIGERATORS»)
     * y si en el de dos mesas con nevera incorporada, que subian delante. A igualdad,
     * manda la disponibilidad, como en 'featured', y despues el orden de siempre (sort es
     * estable).
     */
    function relevancia(p, tokens) {
      const titulo = sinAcentos(p.title || '').toLowerCase();
      // El modelo es el primer tramo del titulo («LRFXS3106S - REFRIGERATORS - …») cuando es
      // una sola palabra. Los titulos descriptivos de Forno («Forno Milano 30-Inch…») no
      // tienen modelo delante, y sin esta condicion «dryer» puntuaba como modelo en «Dryer…».
      const tramo = titulo.split(' - ')[0].trim();
      const modelo = /\s/.test(tramo) ? '' : tramo;
      const sku = String(p.sku || '').toLowerCase();
      const tipo = sinAcentos(p.productType || '').toLowerCase();
      let puntos = 0;
      for (const t of tokens) {
        if (t === modelo || t === sku) puntos += 100;
        else if (t.length >= 3 && modelo.startsWith(t)) puntos += 50;
        if (apareceComoPalabra(t, titulo, false)) puntos += 5;
        if (esDelTipo(t, tipo) || (t.length > 3 && t.endsWith('s') && esDelTipo(t.slice(0, -1), tipo))) puntos += 10;
      }
      return puntos;
    }

    function ordenarPorRelevancia(lista, tokens) {
      const puntos = new Map(lista.map((p) => [p, relevancia(p, tokens)]));
      return lista
        .slice()
        .sort((a, b) => puntos.get(b) - puntos.get(a) || rangoDisponibilidad(a) - rangoDisponibilidad(b));
    }

    function titleExcluded(p, keywords) {
      if (!keywords.length) return false;
      const hay = [p.title, p.handle, p.sku, p.vendor]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return keywords.some((kw) => hay.includes(kw.toLowerCase()));
    }
  
    function shouldSkipProduct(p, cfg) {
      if (titleExcluded(p, cfg.excludeKeywords)) return true;
      const cond = String(p.condition || '').toLowerCase().replace(/\s+/g, '');
      if (cfg.hideTelquelOos && (cond === 'telquel' || cond === 'tel-quel') && p.available === false) {
        return true;
      }
      return false;
    }
  
    function matchesFilters(p, selected, priceMin, priceMax, inStockOnly, ranges) {
      if (inStockOnly && p.available === false) return false;
      const price = Number(p.price);
      if (priceMin != null && !Number.isNaN(priceMin) && (Number.isNaN(price) || price < priceMin)) {
        return false;
      }
      if (priceMax != null && !Number.isNaN(priceMax) && (Number.isNaN(price) || price > priceMax)) {
        return false;
      }
      if (ranges) {
        for (const [key, r] of Object.entries(ranges)) {
          if (!rangeIsActive(r)) continue;
          const n = facetNumber(p[key]);
          // Sin valor numerico no se puede situar en el rango: igual que el precio,
          // el producto cae fuera mientras el rango este activo.
          if (n == null) return false;
          if (r.min != null && n < r.min) return false;
          if (r.max != null && n > r.max) return false;
        }
      }
      for (const [key, values] of Object.entries(selected)) {
        if (!values || !values.length) continue;
        // Pertenencia, no igualdad exacta: un producto pasa si ALGUNO de sus valores esta
        // seleccionado (OR dentro de la faceta). Cubre las facetas de lista (location) y las
        // escalares por igual, porque facetValues normaliza ambas a lista.
        const vals = facetValuesOf(p, key);
        if (!vals.length) return false;
        if (!vals.some((x) => values.includes(x))) return false;
      }
      return true;
    }
  
    function rangoDisponibilidad(p) {
      if (p.available) return 0;
      return p.availability === 'sold_out' ? 2 : 1;
    }

    // '1 filters' salia en los dos idiomas: el texto estaba en plural fijo y se pegaba
    // detras del numero sin mirarlo, y UN filtro marcado es el caso mas comun que hay.
    // En ingles y en frances el plural de estas dos palabras se forma con una 's' final,
    // asi que quitarla basta — y sigue valiendo si alguien cambia el texto desde los
    // ajustes de la seccion, cosa que una clave nueva en TEXTOS no haria.
    function plural(n, palabra) {
      return n === 1 ? String(palabra).replace(/s$/i, '') : palabra;
    }

    function sortProducts(list, mode) {
      const out = list.slice();
      switch (mode) {
        case 'price-asc':
          return out.sort((a, b) => (a.price || 0) - (b.price || 0));
        case 'price-desc':
          return out.sort((a, b) => (b.price || 0) - (a.price || 0));
        case 'title-asc':
          return out.sort((a, b) => String(a.title).localeCompare(String(b.title)));
        case 'title-desc':
          return out.sort((a, b) => String(b.title).localeCompare(String(a.title)));
        case 'created-desc':
          return out.sort(
            (a, b) =>
              Date.parse(b.createdAt || b.created_at || 0) - Date.parse(a.createdAt || a.created_at || 0),
          );
        case 'best-selling':
          return out.sort((a, b) => (b.sales || 0) - (a.sales || 0));
        case 'featured':
        default:
          // 'En vedette' no ordenaba NADA: caia aqui y devolvia el orden del indice, que es
          // el que da Shopify -por id, o sea lo mas viejo primero-. Y como es el valor por
          // defecto del desplegable, todas las colecciones abrian por productos de 2022.
          //
          // Criterio minimo que no inventa politica comercial: primero lo que se puede
          // llevar hoy, luego lo que se pide (el NEUF sin stock, que la casa vende igual en
          // 10-20 dias) y al final lo que no se puede comprar. Dentro de cada grupo se
          // respeta el orden de siempre, porque Array.prototype.sort es estable.
          //
          // `availability` todavia no esta en el indice vivo; mientras no llegue, todo lo no
          // disponible cae en el grupo del medio y esto es simplemente 'vendible primero'.
          return out.sort((a, b) => rangoDisponibilidad(a) - rangoDisponibilidad(b));
      }
    }
  
    function moneyCurrency() {
      return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    }
  
    let formateadorRespaldo = null;

    function formatMoney(n) {
      const importe = Number(n) || 0;

      // El tema ya trae su formateador y el money_format real de la tienda
      // (window.Maximize.currencyFormat, puesto desde layout/theme.liquid). Usarlo es la unica
      // forma de que el precio de la tarjeta instantanea sea IDENTICO al de la tarjeta del tema
      // que la sustituye un instante despues. Antes se veia $1,300 y saltaba a 1 299,99 $ en
      // cada carga, porque aqui se formateaba con el locale DEL NAVEGADOR y sin decimales.
      // El formateador del tema trabaja en centavos; el indice guarda dolares.
      const formato = window.Maximize && window.Maximize.currencyFormat;
      if (formato && typeof window.formatMoney === 'function') {
        try {
          return window.formatMoney(importe * 100, formato);
        } catch (e) {
          /* si el tema cambia de forma, sigue el respaldo de abajo */
        }
      }

      // Respaldo (banco de pruebas, o tema sin ese global): locale de la tienda, no el del
      // navegador, y dos decimales.
      try {
        if (!formateadorRespaldo) {
          formateadorRespaldo = new Intl.NumberFormat(
            (window.Shopify && Shopify.locale) || undefined,
            { style: 'currency', currency: moneyCurrency() },
          );
        }
        return formateadorRespaldo.format(importe);
      } catch {
        return `$${importe}`;
      }
    }
  
    /** Mirror snippets/brand-content-vendor-lookup.liquid normalize */
    function normalizeBrandVendor(vendor) {
      return String(vendor || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/&/g, 'and')
        .replace(/['’]/g, '')
        .replace(/\./g, '')
        .replace(/™/g, '')
        .replace(/[\s-]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '');
    }
  
    /**
     * Mirror snippets/brand-content-vendor-lookup.liquid case aliases.
     * Map is keyed by Brand Content vendor_key (as in brand-content-vendor-image-map).
     */
    const BRAND_VENDOR_KEY_ALIASES = {
      avantgarde: 'avg',
      avg: 'avg',
      distributions_avantgarde: 'avg',
      best_range_hoods: 'best',
      bonprix: 'bonprix_electromenagers',
      cafe: 'cafe',
      cafe_appliances: 'cafe',
      excelsior: 'excelsior_he',
      excelsior_h_e: 'excelsior_he',
      fisher_and_paykel: 'fisher_y_paykel',
      fisher_paykel: 'fisher_y_paykel',
      forno_appliances: 'forno',
      frigidaire_gallery: 'frigidairegallery',
      frigidaire_professional: 'frigidaireprofessional',
      ge_appliance: 'ge',
      ge_appliances: 'ge',
      ge_profile: 'geprofile',
      jenn_air: 'jennair',
      kitchen_aid: 'kitchenaid',
      turbo_air: 'turboair',
    };
  
    function vendorKeyFromName(vendor) {
      const norm = normalizeBrandVendor(vendor);
      if (!norm) return '';
      if (BRAND_VENDOR_KEY_ALIASES[norm]) return BRAND_VENDOR_KEY_ALIASES[norm];
      return norm;
    }
  
    function indexLogoEntry(map, key, entry) {
      if (!key || !entry) return;
      const k = String(key).toLowerCase().trim();
      map[k] = entry;
      const folded = normalizeBrandVendor(k);
      if (folded) map[folded] = entry;
      const compact = folded.replace(/_/g, '');
      if (compact) map[compact] = entry;
    }
  
    function parseVendorLogoMap(raw) {
      const map = {};
      if (!raw) return map;
      if (typeof raw === 'object' && !Array.isArray(raw)) {
        Object.entries(raw).forEach(([k, v]) => {
          const entry =
            v && typeof v === 'object'
              ? { logo: v.logo || '', filter: v.filter || v.logo || '' }
              : { logo: String(v || ''), filter: String(v || '') };
          indexLogoEntry(map, k, entry);
        });
        return map;
      }
      String(raw)
        .split('|')
        .filter(Boolean)
        .forEach((chunk) => {
          const parts = chunk.split('^');
          if (parts.length >= 2 && parts[0]) {
            const entry = { logo: parts[1] || '', filter: parts[2] || parts[1] || '' };
            indexLogoEntry(map, parts[0], entry);
          }
        });
      return map;
    }
  
    function vendorLogoUrl(logoMap, vendor) {
      if (!vendor || !logoMap) return '';
      const key = vendorKeyFromName(vendor);
      const entry =
        logoMap[key] ||
        logoMap[normalizeBrandVendor(vendor)] ||
        logoMap[String(vendor).toLowerCase().trim()] ||
        logoMap[handleize(vendor)];
      if (!entry) return '';
      return entry.filter || entry.logo || '';
    }
  
    function isExcludedVendor(vendor, excluded) {
      const h = handleize(vendor);
      return excluded.some((ex) => handleize(ex) === h || normalizeLabel(ex) === normalizeLabel(vendor));
    }
  
    // Textos por defecto. Antes solo habia ingles escrito a mano en cada campo, asi que una
    // seccion sin configurar salia en ingles en el storefront FR. La clave de filtrado no
    // cambia: esto es solo lo que se ve.
    const TEXTOS = {
      en: {
        loading: 'Loading filters…', products: 'products', filters: 'filters',
        clear: 'Clear filters', reset: 'Reset', filter: 'Filter', sortBy: 'Sort by:',
        close: 'Close', prev: 'Prev', next: 'Next',
        empty: 'No products match these filters.',
          removeFilter: 'Remove \u201c{f}\u201d and see {n} products',
        emptySearch: 'No products match “{q}”.',
        resultsFor: 'Results for “{q}”: ',
        typed: 'you typed “{q}”',
        inStock: 'In stock', price: 'Price', min: 'Min', max: 'Max',
        brand: 'Brand', condition: 'Condition', apply: 'Apply', options: 'Options',
        selected: 'selected',
        indexError: 'The product list could not be loaded. Please refresh the page.',
      },
      fr: {
        loading: 'Chargement des filtres…', products: 'produits', filters: 'filtres',
        clear: 'Effacer les filtres', reset: 'Réinitialiser', filter: 'Filtrer',
        sortBy: 'Trier par :', close: 'Fermer', prev: 'Précédent', next: 'Suivant',
        empty: 'Aucun produit ne correspond à ces filtres.',
          removeFilter: 'Retirer « {f} » et voir {n} produits',
        emptySearch: 'Aucun produit ne correspond à « {q} ».',
        resultsFor: 'Résultats pour « {q} » : ',
        typed: 'vous avez tapé « {q} »',
        inStock: 'En stock', price: 'Prix', min: 'Min', max: 'Max',
        brand: 'Marque', condition: 'Condition', apply: 'Appliquer', options: 'Options',
        selected: 'sélectionné(s)',
        indexError: 'La liste des produits n’a pas pu être chargée. Veuillez rafraîchir la page.',
      },
    };

    function idiomaTienda() {
      const l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
      return String(l).toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
    }

    // Un ajuste sin rellenar llega como cadena vacia, no como ausente: si no se descartan,
    // pisarian el texto por defecto con nada.
    function soloRellenos(obj) {
      const out = {};
      for (const [k, v] of Object.entries(obj || {})) {
        if (v != null && String(v).trim() !== '') out[k] = v;
      }
      return out;
    }

    function readConfig(root) {
      const cfgEl = qs(root, '[data-cf-config]');
      let json = {};
      if (cfgEl) {
        try {
          json = JSON.parse(cfgEl.textContent || '{}');
        } catch (e) {
          // Sin este aviso, un JSON mal escrito en los ajustes de la seccion apaga TODAS las
          // reglas de hide/pin sin dejar rastro: la consola queda limpia y el sintoma es
          // "aparecen facetas que deberian estar ocultas". Es el mecanismo del que dependen
          // las colecciones de liquidacion.
          console.warn('[custom-filters] config JSON invalido, se ignoran las reglas de la seccion:', e.message);
          json = {};
        }
      }
      const i18n = json.i18n || {};
      return {
        excludeKeywords: parseLines(json.excludeTitleKeywords || root.dataset.excludeKeywords || ''),
        priorityRules: parsePriorityRules(json.priorityFilters || ''),
        hiddenRules: parsePriorityRules(json.hiddenFilters || ''),
        excludedVendors: parseLines(json.excludedVendors || 'BonPrix Électroménagers'),
        hideTelquelOos: json.hideTelquelOos !== false,
        expandFilter: json.expandFilter !== false,
        brandColumns: Number(json.brandColumns || 6),
        // 'other' no estaba en el mapa, asi que caia a displayValue y se pintaba la palabra
        // cruda 'other', tambien en la tienda francesa. Son los productos sin etiqueta NEUF
        // ni TELQUEL: 8 una vez fuera garantias y servicios, casi todos Forno (los mismos
        // 8 y 14.994 $ que esNoElectrodomestico se cuida de no borrar en el generador).
        // Y de paso el mismo fallo una fila mas alla: el mapa por defecto era ingles fijo,
        // asi que una seccion sin configurar ponia 'New' y 'Open box' en frances. Es
        // exactamente lo que ya se arreglo para i18n aqui debajo.
        conditionLabels: Object.assign(
          idiomaTienda() === 'fr'
            ? { neuf: 'Neuf', telquel: 'Tel quel', 'tel-quel': 'Tel quel', other: 'Autre' }
            : { neuf: 'New', telquel: 'Open box', 'tel-quel': 'Open box', other: 'Other' },
          soloRellenos(json.conditionLabels || {}),
        ),
        vendorLogoMap: parseVendorLogoMap(json.vendorLogoMap || ''),
        // Los ajustes de la seccion siguen mandando cuando estan rellenos; lo que cambia es el
        // valor por defecto, que antes era siempre ingles. Una coleccion nueva a la que nadie
        // le rellena los 23 textos salia en ingles en el storefront frances.
        i18n: Object.assign({}, TEXTOS[idiomaTienda()], soloRellenos(i18n)),
      };
    }
  
    function init(root) {
      const indexUrl = root.dataset.indexUrl;
      const collectionHandle = root.dataset.collectionHandle || '';
      const searchQuery = root.dataset.searchQuery || '';
      const mode = root.dataset.mode || (searchQuery ? 'search' : 'collection');
      // El <title> de la busqueda lo pone Shopify con SU recuento («1000 results found»), que
      // no es el del panel (592 para «fridges» el 20-oct). Se cambia por el del panel al
      // pintar, conservando lo que va detras del ultimo « – » (el nombre de la tienda).
      const nombreTienda = document.title.split(' – ').pop().trim();
      const perPage = Number(root.dataset.perPage || 24);
      const showVendor = root.dataset.showVendor !== 'false';
      const cfg = readConfig(root);
      const t = cfg.i18n;
  
      const statusEl = qs(root, '[data-cf-status]');
      if (statusEl) {
        // El recuento de resultados cambia en cada filtro y no se anunciaba: quien usa lector
        // de pantalla marcaba una casilla y no recibia confirmacion de nada.
        statusEl.setAttribute('aria-live', 'polite');
        statusEl.setAttribute('aria-atomic', 'true');
      }
      const facetsEls = root.querySelectorAll('[data-cf-facets]');
      const gridEl = qs(root, '[data-cf-grid]');
      const pagerEl = qs(root, '[data-cf-pager]');
      const clearBtn = qs(root, '[data-cf-clear]');
      const clearBtnMobile = qs(root, '[data-cf-clear-mobile]');
      const sortEl = qs(root, '[data-cf-sort]');
      const chipsEl = qs(root, '[data-cf-chips]');
      const advancedEl = qs(root, '[data-cf-advanced]');

      // El boton que aparece cuando la rejilla queda vacia: quita el filtro que sobra.
      // Va delegado sobre la rejilla porque el boton se crea y se destruye en cada
      // repintado, asi que engancharlo al propio boton se perderia al primer render.
      if (gridEl) {
        gridEl.addEventListener('click', (ev) => {
          const btn = ev.target && ev.target.closest && ev.target.closest('[data-cf-quitar]');
          if (!btn) return;
          ev.preventDefault();
          const k = btn.getAttribute('data-cf-quitar') || '';
          const valor = btn.getAttribute('data-cf-quitar-valor') || '';
          if (k === '__instock') state.inStockOnly = false;
          else if (k === '__price') {
            state.priceMin = null;
            state.priceMax = null;
          } else if (k.startsWith('__rmin:') || k.startsWith('__rmax:')) {
            clearRange(k.slice(7));
          } else {
            const resto = (state.selected[k] || []).filter((v) => v !== valor);
            if (resto.length) state.selected[k] = resto;
            else delete state.selected[k];
          }
          state.page = 1;
          medir('cf_quitar_sugerido', { cf_faceta: k });
          render();
          pushUrl();
        });
      }

      // El indicador de deslizamiento de la barra de marcas (solo se ve en movil).
      // Va en fase de CAPTURA y sobre el contenedor de fuera a proposito: el evento
      // scroll no burbujea, y renderAdvanced rehace la barra entera en cada filtrado,
      // asi que un oyente puesto sobre la propia barra se perderia al primer repintado.
      if (advancedEl) {
        advancedEl.addEventListener(
          'scroll',
          (ev) => {
            const carro = ev.target;
            if (!carro || !carro.classList || !carro.classList.contains('slider-container')) return;
            const marca = carro.closest('.custom-filters__advanced-brand');
            const carril = marca && marca.querySelector('[data-cf-brand-swipe]');
            if (!carril) return;
            const recorrido = carro.scrollWidth - carro.clientWidth;
            const avance = recorrido > 0 ? carro.scrollLeft / recorrido : 0;
            carril.style.setProperty('--cf-brand-swipe', String(Math.min(1, Math.max(0, avance))));
          },
          true,
        );
      }
      const drawerEl = qs(root, '[data-cf-drawer]');
      const filterToggleBtn = qs(root, '[data-cf-filter-toggle]');
      const drawerCloseBtns = root.querySelectorAll('[data-cf-drawer-close]');
      let asideFiltersVisible = true;
  
      if (!indexUrl) {
        if (statusEl) statusEl.textContent = 'Set Index JSON URL (or Files filename) in section settings.';
        return;
      }
  
      const state = {
        all: [],
        facetKeys: [],
        facetMeta: { orderedKeys: [], byKey: new Map() },
        selected: {},
        page: 1,
        sort: 'featured',
        priceMin: null,
        priceMax: null,
        range: {},
        inStockOnly: false,
        syncingUrl: false,
      };
  
      // El catalogo base NO depende del estado de los filtros: solo de collectionHandle,
      // searchQuery y cfg, que son fijos tras cargar el indice. Y se pedia mas de 22 veces por
      // render (filtered, countsForKey una vez por faceta, facetExtent por slider, priceExtent
      // y renderAdvanced), o sea 22 recorridos completos del catalogo por cada clic.
      // La cache se invalida donde se asigna state.all, que es lo unico que la mueve.
      let baseCache = null;
      let coberturaCache = null;

      // La consulta ya corregida ([Filtros 90]): se calcula con el catalogo, una vez por
      // indice, igual que baseCache.
      let busquedaCache = null;

      function busqueda() {
        if (!busquedaCache) {
          const originales = palabrasDeConsulta(searchQuery);
          busquedaCache = { tokens: originales, cambios: [] };
          if (searchQuery) {
            const corregida = corregirPalabras(state.all, originales);
            // Una correccion que tampoco encuentra nada no se ensena: «garage refrigerator»
            // acababa en «Résultats pour garbage refrigerator : 0».
            if (corregida.cambios.length && state.all.some((p) => casaConPalabras(p, corregida.tokens))) {
              busquedaCache = corregida;
            }
          }
        }
        return busquedaCache;
      }

      function baseList() {
        if (baseCache) return baseCache;
        const tokens = busqueda().tokens;
        baseCache = state.all
          .filter((p) => productInCollection(p, collectionHandle))
          .filter((p) => casaConPalabras(p, tokens))
          .filter((p) => !shouldSkipProduct(p, cfg));
        return baseCache;
      }
  
      // Que parte de ESTA coleccion conoce la faceta. Se mide sobre el catalogo base
      // -la coleccion entera, sin los filtros marcados- para que el numero no baile
      // segun lo que el cliente vaya tocando.
      function coberturaEnColeccion(key) {
        if (!coberturaCache) coberturaCache = new Map();
        if (coberturaCache.has(key)) return coberturaCache.get(key);
        const base = baseList();
        let cob = 1;
        if (base.length) {
          let con = 0;
          for (const p of base) if (facetValuesOf(p, key).length) con += 1;
          cob = con / base.length;
        }
        coberturaCache.set(key, cob);
        return cob;
      }

      /**
       * Si la faceta sirve para elegir en ESTA coleccion ([Filtros 95]). Una faceta puede
       * tener dato en casi todos y aun asi no distinguir nada: en Refrigerators «Interior
       * light» es «Yes» en el 98 %, y «Category» es REFRIGERATORS en todos menos 2.
       *
       * NO SE ESCONDE POR SER MINORITARIO, que era la idea primera (todo valor dominante
       * del 90 %): se habrian ido las secadoras de gas (7 %), las neveras encastradas (7 %),
       * las secadoras sin salida (5 %) y el modo Sabbath (8 %), que es justo lo que se busca.
       * Lo que se esconde:
       *   - una Si/No en la que el «Si» ya lo tiene el 90 %: marcarlo no filtra casi nada;
       *   - cualquier otra en la que lo que no es el valor dominante son menos de 3
       *     productos o menos del 2 %.
       * Medido el 20-oct-2026 sobre las colecciones de 12+ productos: se pintaban 2.213
       * pares faceta x coleccion y esto quita 297. Las multivalor no se miran: cada producto
       * suma varios valores y el «dominante» no significa nada.
       */
      let distingueCache = null;

      function facetaDistingue(key) {
        if (!distingueCache) distingueCache = new Map();
        if (distingueCache.has(key)) return distingueCache.get(key);
        const cuenta = new Map();
        let con = 0;
        let multivalor = false;
        for (const p of baseList()) {
          const vals = facetValuesOf(p, key);
          if (!vals.length) continue;
          if (vals.length > 1) multivalor = true;
          con += 1;
          for (const v of vals) cuenta.set(String(v), (cuenta.get(String(v)) || 0) + 1);
        }
        let sirve = true;
        if (!multivalor && con) {
          const dominante = Math.max(...cuenta.values());
          const resto = con - dominante;
          const esSiNo = [...cuenta.keys()].every((v) => v === 'Yes' || v === 'No');
          if (esSiNo && (cuenta.get('Yes') || 0) / con >= 0.9) sirve = false;
          else if (resto < 3 || resto / con < 0.02) sirve = false;
        }
        distingueCache.set(key, sirve);
        return sirve;
      }

      function listWithFacetSelection(selectedOverride) {
        let list = baseList();
        list = list.filter((p) =>
          matchesFilters(
            p,
            selectedOverride || state.selected,
            state.priceMin,
            state.priceMax,
            state.inStockOnly,
            state.range,
          ),
        );
        return list;
      }
  
      function filtered() {
        const lista = listWithFacetSelection();
        if (mode === 'search' && searchQuery && state.sort === 'featured') {
          return ordenarPorRelevancia(lista, busqueda().tokens);
        }
        return sortProducts(lista, state.sort);
      }

      /**
       * Cuantos productos quedarian si se quitara SOLO este filtro. Ver [Filtros 77].
       *
       * Existe porque a la rejilla vacia se llega casi siempre por un filtro concreto y el
       * cliente no tiene forma de saber cual. Las CASILLAS no pueden dejarla vacia -un
       * valor con cero resultados ni siquiera se pinta, ver [Filtros 78]-, pero los
       * SLIDERS y el precio si: se aplican como prefiltro, antes del conteo que protege a
       * las casillas. Comprobado en la tienda:
       *     ?cf_vendor=AVIVA&cf_dimensions_depth_min=37&cf_dimensions_depth_max=38
       *     -> «0 products · 3 filters»
       */
      function contarSin(entrada) {
        const sel = { ...state.selected };
        const rangos = { ...state.range };
        let pMin = state.priceMin;
        let pMax = state.priceMax;
        let soloStock = state.inStockOnly;
        const k = entrada.key;
        if (k === '__instock') soloStock = false;
        else if (k === '__price') {
          pMin = null;
          pMax = null;
        } else if (k.startsWith('__rmin:') || k.startsWith('__rmax:')) {
          delete rangos[k.slice(7)];
        } else {
          const resto = (sel[k] || []).filter((v) => v !== entrada.value);
          if (resto.length) sel[k] = resto;
          else delete sel[k];
        }
        let n = 0;
        for (const p of baseList()) {
          if (matchesFilters(p, sel, pMin, pMax, soloStock, rangos)) n += 1;
        }
        return n;
      }
  
      // Conteo de TODAS las facetas en un solo recorrido del catalogo.
      //
      // Antes habia un countsForKey(key) que filtraba el catalogo entero una vez por faceta,
      // para poder excluir del conteo la seleccion de esa misma faceta (si no, marcar "Laval"
      // dejaria el resto de ubicaciones a cero y no se podrian combinar). Con ~20 grupos eso
      // eran ~20 pasadas por render.
      //
      // La misma semantica sale de una sola pasada contando cuantas facetas FALLA cada
      // producto:
      //   falla 0  -> pasa todos los filtros: suma en todas las facetas
      //   falla 1  -> suma solo en la faceta que falla (es justo la que se excluye a si misma)
      //   falla 2+ -> no suma en ninguna
      // Precio, stock y rangos no son facetas de casilla: se aplican antes como prefiltro,
      // igual que hacia countsForKey al pasarles state.range entero.
      function computeAllCounts(keys) {
        const counts = {};
        for (const k of keys) counts[k] = {};
        const activas = Object.entries(state.selected).filter(([, v]) => v && v.length);

        const sumar = (p, k) => {
          const map = counts[k];
          if (!map) return;
          // Un incremento por cada valor real: una faceta de lista (location) cuenta cada
          // ubicacion por separado, en vez de contar el string crudo con corchetes.
          for (const val of facetValuesOf(p, k)) map[val] = (map[val] || 0) + 1;
        };

        for (const p of baseList()) {
          if (!matchesFilters(p, {}, state.priceMin, state.priceMax, state.inStockOnly, state.range)) {
            continue;
          }
          let fallidas = 0;
          let laQueFalla = null;
          for (const [k, values] of activas) {
            const vals = facetValuesOf(p, k);
            if (!vals.length || !vals.some((x) => values.includes(x))) {
              fallidas++;
              if (fallidas > 1) break;
              laQueFalla = k;
            }
          }
          if (fallidas > 1) continue;
          if (fallidas === 1) {
            sumar(p, laQueFalla);
            continue;
          }
          for (const k of keys) sumar(p, k);
        }
        return counts;
      }
      // Cuando un solo producto raro estira el recorrido del slider. Ver [Filtros 74].
      //
      // MEDIDO sobre el indice vivo, cuanto del recorrido queda SIN UN SOLO PRODUCTO:
      //    class_width              65 %   (12 a 81 pulgadas, p95 en 36)
      //    capacity_refrigerator    54 %   (1 a 45 pi3, p95 en 21,4; el 45 es UNA nevera
      //                                     comercial OMCAN de puertas correderas)
      //    capacity_total           36 %
      // Arrastrar sobre vacio no es solo feo: con el extremo en 45, mover el pulgar un
      // pixel salta mas litros de los que separan dos neveras normales, asi que el filtro
      // pierde precision justo donde esta casi todo el catalogo.
      //
      // NO SE CORTA SIEMPRE, y las dos guardas importan:
      //   1. solo si la cola es LARGA (el maximo pasa del p95 por mas de la mitad). Asi
      //      dimensions_height (14 % vacio) o spec_decibels (22 %) se quedan como estan
      //   2. solo si la faceta tiene MUCHOS valores distintos. number_of_burners va de 4 a
      //      8 y number_of_temperature_settings de 2 a 10: son cuentas pequenas donde cada
      //      escalon significa algo y recortarlas seria perder opciones de verdad
      //
      // LOS DE ARRIBA SIGUEN SIENDO ALCANZABLES: cuando el pulgar esta en el maximo, el
      // codigo que guarda el rango ya pone null -o sea, sin tope- en vez del numero. Asi
      // que con el slider al final entran tambien los que quedan por encima del corte.
      const COLA_LARGA = 1.5;
      const VALORES_PARA_CORTAR = 20;

      function extremoPodado(nums) {
        const max = nums[nums.length - 1];
        if (new Set(nums).size < VALORES_PARA_CORTAR) return max;
        const p95 = nums[Math.min(nums.length - 1, Math.floor(nums.length * 0.95))];
        return max > p95 * COLA_LARGA ? p95 : max;
      }

      // Extent de una faceta de rango. Igual que countsForKey, se calcula ignorando la
      // propia faceta, para que el rango disponible refleje las OTRAS selecciones activas.
      function facetExtent(key) {
        const others = { ...state.selected };
        delete others[key];
        const otherRanges = { ...state.range };
        delete otherRanges[key];
        const list = baseList().filter((p) =>
          matchesFilters(p, others, state.priceMin, state.priceMax, state.inStockOnly, otherRanges),
        );
        const nums = [];
        for (const p of list) {
          const n = facetNumber(p[key]);
          if (n != null) nums.push(n);
        }
        if (!nums.length) return null;
        nums.sort((a, b) => a - b);
        const lo = nums[0];
        const hi = extremoPodado(nums);
        const min = Math.floor(lo);
        const max = Math.max(Math.ceil(hi), min + 1);
        return { min, max };
      }
      function clearRange(key) {
        delete state.range[key];
      }
  
      function activeEntries() {
        const entries = [];
        for (const [key, values] of Object.entries(state.selected)) {
          for (const v of values || []) {
            entries.push({
              key,
              value: v,
              label: `${displayLabel(state.facetMeta, key)}: ${displayValue(state.facetMeta, key, v)}`,
            });
          }
        }
        if (state.inStockOnly) entries.push({ key: '__instock', value: '1', label: t.inStock });
        if (state.priceMin != null) entries.push({ key: '__pmin', value: String(state.priceMin), label: `${t.min} ${formatMoney(state.priceMin)}` });
        if (state.priceMax != null) entries.push({ key: '__pmax', value: String(state.priceMax), label: `${t.max} ${formatMoney(state.priceMax)}` });
        for (const [key, r] of Object.entries(state.range)) {
          if (!rangeIsActive(r)) continue;
          const unit = (facetRangeMeta(state.facetMeta, key) || {}).unit || '';
          const suf = unit ? ` ${unit}` : '';
          const name = displayLabel(state.facetMeta, key);
          if (r.min != null) {
            entries.push({ key: `__rmin:${key}`, value: String(r.min), label: `${name}: ${t.min} ${r.min}${suf}` });
          }
          if (r.max != null) {
            entries.push({ key: `__rmax:${key}`, value: String(r.max), label: `${name}: ${t.max} ${r.max}${suf}` });
          }
        }
        return entries;
      }
  
      // MEDICION DEL PANEL. Hasta ahora no se media nada: no habia forma de saber que
      // facetas usa la gente, cuales no toca nadie, ni cuantas veces alguien se queda sin
      // resultados. Ver [Filtros 69].
      //
      // Se emite por gtag porque GA4 YA ESTA en la tienda (G-MQSVG618QD, puesto por el
      // canal de Google), asi que no hay que anadir ninguna libreria.
      //
      // VA ENVUELTO EN try/catch Y COMPRUEBA QUE gtag EXISTA, a proposito: si el cliente
      // ha rechazado cookies, o el script de Google tarda, o Google cambia la firma, el
      // panel de filtros TIENE que seguir funcionando. Medir no puede tumbar la tienda.
      function medir(evento, datos) {
        try {
          if (typeof window.gtag !== 'function') return;
          window.gtag(
            'event',
            evento,
            Object.assign({ cf_ambito: mode === 'search' ? 'busqueda' : collectionHandle || '' }, datos),
          );
        } catch (e) {
          /* la medicion nunca puede romper el filtrado */
        }
      }

      function setFacetValue(key, value, on) {
        const set = new Set(state.selected[key] || []);
        if (on) set.add(value);
        else set.delete(value);
        state.selected[key] = [...set];
        if (!state.selected[key].length) delete state.selected[key];
        state.page = 1;
        medir('cf_filtro_valor', {
          cf_faceta: key,
          cf_valor: String(value).slice(0, 80),
          cf_accion: on ? 'marcar' : 'desmarcar',
        });
        render();
        pushUrl();
      }
  
      function clearAll() {
        medir('cf_limpiar_todo', { cf_filtros: activeEntries().length });
        state.selected = {};
        state.priceMin = null;
        state.priceMax = null;
        state.range = {};
        state.inStockOnly = false;
        state.page = 1;
        // No se toca el DOM aqui: los inputs de precio y el toggle de stock viven dentro
        // de [data-cf-facets] y renderFacets los reconstruye desde state en cada render.
        render();
        pushUrl();
      }
  
      function renderChips() {
        if (!chipsEl) return;
        const entries = activeEntries();
        if (!entries.length) {
          chipsEl.innerHTML = '';
          chipsEl.hidden = true;
          return;
        }
        chipsEl.hidden = false;
        chipsEl.innerHTML = entries
          .map(
            (e) =>
              `<button type="button" class="custom-filters__chip" data-cf-chip-key="${escapeAttr(e.key)}" data-cf-chip-value="${escapeAttr(e.value)}">${escapeHtml(e.label)} <span aria-hidden="true">×</span></button>`,
          )
          .join('');
        chipsEl.querySelectorAll('[data-cf-chip-key]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const key = btn.getAttribute('data-cf-chip-key');
            const value = btn.getAttribute('data-cf-chip-value');
            if (key === '__instock') {
              state.inStockOnly = false;
            } else if (key === '__pmin') {
              state.priceMin = null;
            } else if (key === '__pmax') {
              state.priceMax = null;
            } else if (key && (key.startsWith('__rmin:') || key.startsWith('__rmax:'))) {
              const rk = key.slice(7);
              const cur = state.range[rk];
              if (cur) {
                if (key.startsWith('__rmin:')) cur.min = null;
                else cur.max = null;
                if (!rangeIsActive(cur)) clearRange(rk);
              }
            } else {
              setFacetValue(key, value, false);
              return;
            }
            state.page = 1;
            render();
            pushUrl();
          });
        });
      }
  
      function navArrowSvg() {
        // Same as snippets/icon-all icon-nav-arrow (points right); theme rotates prev 180deg.
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true" class="slider-nav__icon w-full h-full" style="fill:none"><path d="M7 18L13 10L7 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      }
  
      function conditionClass(cond) {
        const norm = String(cond || '')
          .toLowerCase()
          .replace(/\s+/g, '');
        if (norm.includes('neuf')) return 'advanced-filter__label--condition-neuf';
        if (norm.includes('telquel') || norm.includes('tel-quel')) return 'advanced-filter__label--condition-telquel';
        return '';
      }
  
      function sortConditionKeys(keys) {
        // Match default S&D order on Bonprix: Open box / Tel quel first, then New / Neuf
        const rank = (c) => {
          const n = String(c).toLowerCase().replace(/\s+/g, '');
          if (n.includes('telquel') || n.includes('tel-quel')) return 0;
          if (n.includes('neuf')) return 1;
          return 2;
        };
        return keys.slice().sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
      }
  
      function initBrandSwiffy(sliderEl, slideCount) {
        if (!sliderEl || slideCount <= cfg.brandColumns) return;
        const store = window.Alpine && Alpine.store && Alpine.store('xSwiffy');
        if (!store || typeof store.load !== 'function') return;
        store.load(sliderEl, {
          mediaQuery: 'min',
          isLoop: false,
          isResize: true,
          adaptWidth: true,
          breakPoints: {
            0: { slidesPerView: Math.min(2, slideCount) },
            768: { slidesPerView: Math.min(3, slideCount) },
            1024: { slidesPerView: Math.min(cfg.brandColumns || 6, slideCount) },
          },
        });
      }
  
      let advancedSignature = '';

      // Conteos de todas las facetas del render en curso, calculados de una vez en renderAhora
      // y consumidos por el panel lateral (renderFacets) y por las barras (renderAdvanced).
      let conteosDelRender = {};
  
      function syncAdvancedActiveState() {
        if (!advancedEl) return;
        const sincronizar = (atributo, clave) => {
          advancedEl.querySelectorAll(`[${atributo}]`).forEach((el) => {
            const v = el.getAttribute(atributo);
            const on = (state.selected[clave] || []).includes(v);
            el.classList.toggle('is-cf-active', on);
            el.setAttribute('aria-checked', on ? 'true' : 'false');
            const input = el.querySelector('input');
            if (input) input.checked = on;
          });
        };
        sincronizar('data-cf-adv-vendor', 'vendor');
        sincronizar('data-cf-adv-condition', 'condition');
      }
  
      // Solo se escuchaba Enter, asi que la BARRA ESPACIADORA -el gesto estandar para marcar
      // una casilla- no hacia nada en estas pildoras. Se usa keydown y no keyup porque hay que
      // preventDefault el espacio: si no, la pagina hace scroll.
      //
      // Lo ideal seria que el control focusable fuese el <input> de verdad, pero la pildora de
      // condicion lo lleva con la clase "hidden" (display:none), que NO puede recibir foco, y
      // ese CSS vive en el tema, fuera de este repo. Con role/aria-checked el lector anuncia el
      // estado correctamente sin tocar una sola clase.
      function ligarPildora(el, clave, atributo) {
        const toggle = () => {
          const v = el.getAttribute(atributo);
          setFacetValue(clave, v, !(state.selected[clave] || []).includes(v));
        };
        el.addEventListener('click', (e) => {
          e.preventDefault();
          toggle();
        });
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            toggle();
          }
        });
      }

      function bindAdvancedClicks() {
        advancedEl
          .querySelectorAll('[data-cf-adv-vendor]')
          .forEach((el) => ligarPildora(el, 'vendor', 'data-cf-adv-vendor'));
        advancedEl
          .querySelectorAll('[data-cf-adv-condition]')
          .forEach((el) => ligarPildora(el, 'condition', 'data-cf-adv-condition'));
      }
  
      function renderAdvanced() {
        if (!advancedEl) return;
        // Antes se contaba sobre baseList(), o sea SIN los filtros activos: tras filtrar por
        // Laval y lavavajillas, la barra seguia ofreciendo marcas que ya no tenian ni un
        // producto y el cliente se quedaba en cero resultados. Ahora se cuenta como cualquier
        // otra faceta, excluyendo la propia seleccion para poder deseleccionar.
        const vendorCounts = conteosDelRender.vendor || {};
        const condCounts = conteosDelRender.condition || {};

        const vendors = Object.keys(vendorCounts)
          .filter((v) => !isExcludedVendor(v, cfg.excludedVendors))
          .filter((v) => vendorCounts[v] > 0)
          .sort((a, b) => a.localeCompare(b));
        const condKeys = sortConditionKeys(Object.keys(condCounts));
        // La huella incluye los conteos: ahora cambian al filtrar, y si no se repintaria el
        // numero viejo.
        const signature =
          vendors.map((v) => `${v}:${vendorCounts[v]}`).join('\0') +
          '::' +
          condKeys.map((c) => `${c}:${condCounts[c]}`).join('\0');
  
        if (signature === advancedSignature && advancedEl.children.length) {
          syncAdvancedActiveState();
          return;
        }
        advancedSignature = signature;
  
        const brandCols = cfg.brandColumns || 6;
        const useSlider = vendors.length > brandCols;
        const brandSlides = vendors
          .map((v, i) => {
            const active = (state.selected.vendor || []).includes(v);
            const logo = vendorLogoUrl(cfg.vendorLogoMap, v);
            // CF34: con logo no hay texto donde meter el numero sin inventarse una clase de CSS
            // que vive en el tema. Va en el title y en el aria-label, que es donde lo buscan el
            // raton y el lector de pantalla. Sin logo si se pinta al lado del nombre.
            const n = vendorCounts[v] || 0;
            // CF86: el texto de reserva se pintaba DENTRO del circulo de la imagen, que
            // mide 60px y lleva overflow-hidden, asi que de «Bon Sommeil (5)» solo se veia una
            // tira del medio -«on Somme» y debajo «(5)»-. Con logo va el circulo; sin logo, el
            // nombre suelto y legible. Marcas sin logo en el indice vivo: Bon Sommeil y OMCAN.
            const media = logo
              ? `<div class="cf-brand-logo w-[60px] h-[60px] md:w-[68px] md:h-[68px] relative shrink-0 inline-block overflow-hidden color-filter transition duration-200 rounded-full"><img src="${escapeAttr(logo)}" alt="${escapeAttr(v)}" width="400" height="400" loading="lazy" class="w-full h-full object-contain top-0 left-0 absolute p-0.5"/></div>`
              : `<span class="filter-label text-small p-break-words line-clamp-2">${escapeHtml(v)} (${n})</span>`;
            return `<div id="CfBrandSlide-${i}" class="group slide-item shrink-0 relative text-center">
              <label class="advanced-filter__label anm-hover-button relative cursor-pointer rounded-corners text-small border color-border-[rgba(var(--color-text),0.2)] advanced-filter-image advanced-filter-image--logo-only flex w-full h-full justify-center items-center px-2 md:px-3 pt-1.5 pb-1.5 md:pt-2 md:pb-2${active ? ' is-cf-active' : ''}" data-cf-adv-vendor="${escapeAttr(v)}" title="${escapeAttr(v)} (${n})" role="checkbox" aria-checked="${active ? 'true' : 'false'}" aria-label="${escapeAttr(v)} (${n})" tabindex="0">
                <input type="checkbox" class="input-image-filter absolute opacity-0" tabindex="-1" aria-hidden="true" ${active ? 'checked' : ''}/>
                <div class="image-filter w-full h-full flex justify-center items-center rounded-corners">
                  <div class="inline-flex gap-2 md:gap-3 items-center justify-center w-auto mx-auto">
                    ${media}
                  </div>
                </div>
              </label>
            </div>`;
          })
          .join('');
  
        const brandCount = Math.min(brandCols, vendors.length);
        // CF86: la barra de marcas se queda aunque haya una sola, por decision del cliente
        // (2-oct): ahi hace de marca de la casa, no solo de filtro. En 59 de las 332
        // colecciones con 3+ productos hay una marca unica -cafe con 106, cafe-1 con 98- y en
        // esas el logo es justamente lo que se quiere ver. La de condicion si se esconde: ahi
        // un valor unico es solo ruido.
        const brandHtml = vendors.length
          ? `<div class="js-filter filter-advanced-desktop pl-0 pr-0 ${useSlider ? 'lg:pl-12 lg:pr-12' : ''} mb-3 maximize mx-auto page-width contain-image custom-filters__advanced-brand">
              <div class="block webkit-text-left md:webkit-text-center contain-image">
                <div class="${useSlider ? 'swiffy-slider slider-item-snapstart text-left list-item-wrapper' : 'list-item-wrapper w-full'}" data-cf-brand-slider style="--cf-brand-cols:${brandCount};--swiffy-slider-item-gap:8px;">
                  ${
                    useSlider
                      ? `<button type="button" class="slider-nav is-visible slider-nav__button-arrow advanced-nav top-1/2 translate-y-1/2 md:translate-y-0 anm-button-secondary" aria-label="Previous">${navArrowSvg()}</button>
                         <button type="button" class="slider-nav slider-nav-next is-visible slider-nav__button-arrow advanced-nav top-1/2 translate-y-1/2 md:translate-y-0 anm-button-secondary" aria-label="Next">${navArrowSvg()}</button>`
                      : ''
                  }
                  <div class="slider-container scrollbar-hidden lg:px-0.5 lg:mx-1 lg:scroll-px-0.5" style="--cf-brand-cols:${brandCount};--swiffy-slider-item-gap:8px;" data-mobile-gap="6px" data-desktop-gap="8px">
                    ${brandSlides}
                  </div>
                </div>
                ${
                  vendors.length > 5
                    ? `<div class="custom-filters__brand-swipe" data-cf-brand-swipe aria-hidden="true"></div>`
                    : ''
                }
              </div>
            </div>`
          : '';
  
        const condSlides = condKeys
          .map((c, i) => {
            const active = (state.selected.condition || []).includes(c);
            const norm = String(c).toLowerCase().replace(/\s+/g, '');
            const label =
              cfg.conditionLabels[norm] ||
              cfg.conditionLabels[norm.replace('-', '')] ||
              displayValue(state.facetMeta, 'condition', c);
            const condClass = conditionClass(c);
            return `<div id="CfCondSlide-${i}" class="advanced-filter-text group slide-item shrink-0 w-full h-full relative text-center">
              <label class="advanced-filter__label-text advanced-filter__label anm-hover-button rounded-corners relative text-small cursor-pointer w-full border color-border-[rgba(var(--color-text),0.2)] h-full inline-flex justify-center items-center px-4 py-4 fitler-not-image ${condClass}${active ? ' is-cf-active' : ''}" data-cf-adv-condition="${escapeAttr(c)}" role="checkbox" aria-checked="${active ? 'true' : 'false'}" aria-label="${escapeAttr(label)} (${condCounts[c] || 0})" tabindex="0">
                <input type="checkbox" class="input-filter-checkbox hidden" ${active ? 'checked' : ''} tabindex="-1" aria-hidden="true"/>
                <span class="filter-label p-break-words inline-block line-clamp-3">${escapeHtml(label)} (${condCounts[c] || 0})</span>
              </label>
            </div>`;
          })
          .join('');
  
        const condHtml = condKeys.length > 1
          ? `<div class="js-filter filter-advanced-desktop pl-0 pr-0 mt-1 md:mt-3 mb-3 maximize mx-auto page-width custom-filters__advanced-condition">
              <div class="block webkit-text-left">
                <div class="list-item-wrapper w-full">
                  <div class="slider-container scrollbar-hidden lg:px-0.5 lg:mx-1" style="--swiffy-slider-item-count:${Math.min(2, condKeys.length)};--swiffy-slider-item-gap:8px;">
                    ${condSlides}
                  </div>
                </div>
              </div>
            </div>`
          : '';
  
        advancedEl.innerHTML = brandHtml + condHtml;
        initBrandSwiffy(qs(advancedEl, '[data-cf-brand-slider]'), vendors.length);
        bindAdvancedClicks();
      }
  
      function priceExtent() {
        let lo = Infinity;
        let hi = 0;
        for (const p of baseList()) {
          const n = Number(p.price);
          if (Number.isNaN(n)) continue;
          lo = Math.min(lo, n);
          hi = Math.max(hi, n);
        }
        if (!Number.isFinite(lo)) return { min: 0, max: 1000 };
        const min = Math.floor(lo);
        const max = Math.max(Math.ceil(hi), min + 1);
        return { min, max };
      }
  
      function bindPriceSlider(scope) {
        const wrap = qs(scope, '[data-cf-price-slider]');
        if (!wrap) return;
        const extentMin = Number(wrap.getAttribute('data-min')) || 0;
        const extentMax = Number(wrap.getAttribute('data-max')) || 1000;
        const rangeMin = qs(wrap, '[data-cf-range-min]');
        const rangeMax = qs(wrap, '[data-cf-range-max]');
        const progress = qs(wrap, '[data-cf-price-progress]');
        const minInner = qs(scope, '[data-cf-price-min-inner]');
        const maxInner = qs(scope, '[data-cf-price-max-inner]');
        const span = Math.max(1, extentMax - extentMin);
  
        const syncProgress = () => {
          if (!progress || !rangeMin || !rangeMax) return;
          const a = Number(rangeMin.value);
          const b = Number(rangeMax.value);
          const left = ((Math.min(a, b) - extentMin) / span) * 100;
          const right = ((extentMax - Math.max(a, b)) / span) * 100;
          progress.style.left = `${Math.max(0, left)}%`;
          progress.style.right = `${Math.max(0, right)}%`;
        };
  
        const applyPrice = (commit) => {
          let minV = minInner && minInner.value !== '' ? Number(minInner.value) : null;
          let maxV = maxInner && maxInner.value !== '' ? Number(maxInner.value) : null;
          if (minV != null && Number.isNaN(minV)) minV = null;
          if (maxV != null && Number.isNaN(maxV)) maxV = null;
          if (minV != null && maxV != null && minV > maxV) {
            const tmp = minV;
            minV = maxV;
            maxV = tmp;
          }
          const atFloor = minV == null || minV <= extentMin;
          const atCeil = maxV == null || maxV >= extentMax;
          state.priceMin = atFloor ? null : minV;
          state.priceMax = atCeil ? null : maxV;
          if (commit) {
            state.page = 1;
            render();
            pushUrl();
          }
        };
  
        const syncFromRanges = (commit) => {
          if (!rangeMin || !rangeMax) return;
          let a = Number(rangeMin.value);
          let b = Number(rangeMax.value);
          if (a > b) {
            if (rangeMin === document.activeElement) b = a;
            else a = b;
            rangeMin.value = String(a);
            rangeMax.value = String(b);
          }
          if (minInner) minInner.value = String(a);
          if (maxInner) maxInner.value = String(b);
          syncProgress();
          applyPrice(commit);
        };
  
        const syncFromInputs = (commit) => {
          let a = minInner && minInner.value !== '' ? Number(minInner.value) : extentMin;
          let b = maxInner && maxInner.value !== '' ? Number(maxInner.value) : extentMax;
          if (Number.isNaN(a)) a = extentMin;
          if (Number.isNaN(b)) b = extentMax;
          a = Math.min(Math.max(a, extentMin), extentMax);
          b = Math.min(Math.max(b, extentMin), extentMax);
          if (a > b) {
            const tmp = a;
            a = b;
            b = tmp;
          }
          if (rangeMin) rangeMin.value = String(a);
          if (rangeMax) rangeMax.value = String(b);
          syncProgress();
          applyPrice(commit);
        };
  
        if (rangeMin) {
          rangeMin.addEventListener('input', () => syncFromRanges(false));
          rangeMin.addEventListener('change', () => syncFromRanges(true));
        }
        if (rangeMax) {
          rangeMax.addEventListener('input', () => syncFromRanges(false));
          rangeMax.addEventListener('change', () => syncFromRanges(true));
        }
        if (minInner) minInner.addEventListener('change', () => syncFromInputs(true));
        if (maxInner) maxInner.addEventListener('change', () => syncFromInputs(true));
        syncProgress();
      }
  
      // Binder generico de sliders de rango por faceta. Espeja bindPriceSlider pero
      // parametrizado por clave, escribiendo en state.range[key]. El precio conserva su
      // binder propio: no se toca un control que ya funciona en produccion.
      function bindRangeSliders(scope) {
        scope.querySelectorAll('[data-cf-range-group]').forEach((group) => {
          const key = group.getAttribute('data-cf-range-group');
          const wrap = qs(group, '[data-cf-range-slider]');
          if (!key || !wrap) return;
          const extentMin = Number(wrap.getAttribute('data-min'));
          const extentMax = Number(wrap.getAttribute('data-max'));
          if (!Number.isFinite(extentMin) || !Number.isFinite(extentMax)) return;
          const rangeMin = qs(group, '[data-cf-rs-min]');
          const rangeMax = qs(group, '[data-cf-rs-max]');
          const progress = qs(group, '[data-cf-rs-progress]');
          const minInner = qs(group, '[data-cf-rs-min-inner]');
          const maxInner = qs(group, '[data-cf-rs-max-inner]');
          const span = Math.max(1, extentMax - extentMin);
          const syncProgress = () => {
            if (!progress || !rangeMin || !rangeMax) return;
            const a = Number(rangeMin.value);
            const b = Number(rangeMax.value);
            const left = ((Math.min(a, b) - extentMin) / span) * 100;
            const right = ((extentMax - Math.max(a, b)) / span) * 100;
            progress.style.left = `${Math.max(0, left)}%`;
            progress.style.right = `${Math.max(0, right)}%`;
          };
          const apply = (commit) => {
            let minV = minInner && minInner.value !== '' ? Number(minInner.value) : null;
            let maxV = maxInner && maxInner.value !== '' ? Number(maxInner.value) : null;
            if (minV != null && Number.isNaN(minV)) minV = null;
            if (maxV != null && Number.isNaN(maxV)) maxV = null;
            if (minV != null && maxV != null && minV > maxV) {
              const tmp = minV;
              minV = maxV;
              maxV = tmp;
            }
            // En el extremo se guarda null, para que el filtro no cuente como activo.
            const lo = minV == null || minV <= extentMin ? null : minV;
            const hi = maxV == null || maxV >= extentMax ? null : maxV;
            state.range[key] = { min: lo, max: hi };
            if (!rangeIsActive(state.range[key])) clearRange(key);
            if (commit) {
              state.page = 1;
              // Solo al SOLTAR el pulgar, no mientras se arrastra: si no, un arrastre
              // mandaria decenas de eventos y la medicion no diria nada.
              medir('cf_filtro_rango', {
                cf_faceta: key,
                cf_min: lo == null ? '' : String(lo),
                cf_max: hi == null ? '' : String(hi),
              });
              render();
              pushUrl();
            }
          };
          const syncFromRanges = (commit) => {
            if (!rangeMin || !rangeMax) return;
            let a = Number(rangeMin.value);
            let b = Number(rangeMax.value);
            if (a > b) {
              if (rangeMin === document.activeElement) b = a;
              else a = b;
              rangeMin.value = String(a);
              rangeMax.value = String(b);
            }
            if (minInner) minInner.value = String(a);
            if (maxInner) maxInner.value = String(b);
            syncProgress();
            apply(commit);
          };
          const syncFromInputs = (commit) => {
            let a = minInner && minInner.value !== '' ? Number(minInner.value) : extentMin;
            let b = maxInner && maxInner.value !== '' ? Number(maxInner.value) : extentMax;
            if (Number.isNaN(a)) a = extentMin;
            if (Number.isNaN(b)) b = extentMax;
            a = Math.min(Math.max(a, extentMin), extentMax);
            b = Math.min(Math.max(b, extentMin), extentMax);
            if (a > b) {
              const tmp = a;
              a = b;
              b = tmp;
            }
            if (rangeMin) rangeMin.value = String(a);
            if (rangeMax) rangeMax.value = String(b);
            syncProgress();
            apply(commit);
          };
          if (rangeMin) {
            rangeMin.addEventListener('input', () => syncFromRanges(false));
            rangeMin.addEventListener('change', () => syncFromRanges(true));
          }
          if (rangeMax) {
            rangeMax.addEventListener('input', () => syncFromRanges(false));
            rangeMax.addEventListener('change', () => syncFromRanges(true));
          }
          if (minInner) minInner.addEventListener('change', () => syncFromInputs(true));
          if (maxInner) maxInner.addEventListener('change', () => syncFromInputs(true));
          syncProgress();
        });
      }
      function bindFacetControls(scope) {
        scope.querySelectorAll('input[data-cf-facet]').forEach((input) => {
          input.addEventListener('change', () => {
            setFacetValue(input.getAttribute('data-cf-facet'), input.value, input.checked);
          });
        });
  
        // «+N»: ensena el resto de valores de esa faceta. No repinta el panel -seria
        // perder el foco y el scroll-, solo le quita la clase que los escondia.
        scope.querySelectorAll('[data-cf-more]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const cuerpo = btn.closest('.custom-filters__group-body');
            if (!cuerpo) return;
            cuerpo.querySelectorAll('.is-cf-extra').forEach((el) => el.classList.remove('is-cf-extra'));
            const clave = btn.getAttribute('data-cf-more');
            if (clave) facetasDesplegadas.add(clave);
            btn.setAttribute('aria-expanded', 'true');
            btn.remove();
          });
        });

        // Buscador dentro de la faceta. Filtra en el DOM, sin tocar el estado ni repintar:
        // escribir aqui NO filtra productos, solo acorta la lista de opciones.
        scope.querySelectorAll('[data-cf-facet-search]').forEach((input) => {
          input.addEventListener('input', () => {
            const q = sinAcentos(input.value || '').toLowerCase().trim();
            const cuerpo = input.closest('.custom-filters__group-body');
            if (!cuerpo) return;
            const boton = cuerpo.querySelector('[data-cf-more]');
            cuerpo.querySelectorAll('[data-cf-buscable]').forEach((op) => {
              const casa = !q || (op.getAttribute('data-cf-buscable') || '').includes(q);
              op.classList.toggle('is-cf-oculto', !casa);
              // Al buscar se mira TODA la lista, no solo los 8 primeros: si no, buscar
              // una marca que esta la 30 no la encontraria nunca.
              if (q) op.classList.remove('is-cf-extra');
            });
            if (boton) boton.style.display = q ? 'none' : '';
          });
        });

        scope.querySelectorAll('[data-cf-facet-reset]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const key = btn.getAttribute('data-cf-facet-reset');
            if (key === '__price') {
              state.priceMin = null;
              state.priceMax = null;
            } else if (key && facetRangeMeta(state.facetMeta, key)) {
              clearRange(key);
            } else if (key) {
              state.selected[key] = [];
            }
            state.page = 1;
            render();
            pushUrl();
          });
        });
  
        bindPriceSlider(scope);
        bindRangeSliders(scope);
  
        const stockInner = qs(scope, '[data-cf-instock-inner]');
        if (stockInner) {
          stockInner.addEventListener('change', () => {
            state.inStockOnly = stockInner.checked;
            state.page = 1;
            render();
            pushUrl();
          });
        }
      }
  
      // Original CF JS always used <details open>. Preserve user toggles across re-renders.
      const facetOpenState = new Map();
  
      function captureFacetOpenState() {
        facetsEls.forEach((rootEl) => {
          rootEl.querySelectorAll('[data-cf-group]').forEach((details) => {
            const key = details.getAttribute('data-cf-group');
            if (key) facetOpenState.set(key, !!details.open);
          });
        });
      }
  
      function groupOpenAttr(key) {
        // Default = open (hardcoded in original custom-filters.js). expandFilter only forces closed when false.
        const open = facetOpenState.has(key)
          ? facetOpenState.get(key)
          : cfg.expandFilter !== false;
        return open ? ' open' : '';
      }
  
      function facetCaretSvg() {
        return `<svg class="custom-filters__group-caret-icon" width="100%" height="100%" viewBox="0 0 9 7" fill="none" aria-hidden="true"><path d="M0.75 1.625L4.5 5.375L8.25 1.625" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      }
  
      // Bloque de faceta renderizado como Range Slider. Reutiliza a proposito las clases
      // custom-filters__price-*: el CSS vive en el tema, fuera de este repo, asi que un
      // nombre de clase nuevo saldria sin estilos.
      function rangeFacetBlock(key, rangeMeta, resetLabel, caret) {
        const extent = facetExtent(key);
        if (!extent) return '';
        const cur = state.range[key] || {};
        const curMin = cur.min != null ? cur.min : extent.min;
        const curMax = cur.max != null ? cur.max : extent.max;
        const active = rangeIsActive(cur);
        const step = rangeMeta.step || 1;
        const unit = rangeMeta.unit ? ` (${rangeMeta.unit})` : '';
        const title = `${displayLabel(state.facetMeta, key)}${unit}`;
        const tools = `<div class="custom-filters__group-tools custom-filters__group-tools--end">
          <button type="button" class="custom-filters__facet-reset" data-cf-facet-reset="${escapeAttr(key)}">${escapeHtml(resetLabel)}</button>
        </div>`;
        return `<details class="custom-filters__group${active ? ' has-active' : ''}" data-cf-group="${escapeAttr(key)}"${groupOpenAttr(key)}>
          <summary>
            <span class="custom-filters__group-title">${escapeHtml(title)}</span>
            <span class="custom-filters__group-caret" aria-hidden="true">${caret}</span>
          </summary>
          <div class="custom-filters__group-body" data-cf-range-group="${escapeAttr(key)}">
            ${tools}
            <div class="custom-filters__price-slider" data-cf-range-slider="${escapeAttr(key)}" data-min="${extent.min}" data-max="${extent.max}">
              <div class="custom-filters__price-track">
                <div class="custom-filters__price-progress" data-cf-rs-progress></div>
              </div>
              <div class="custom-filters__price-ranges">
                <input type="range" data-cf-rs-min min="${extent.min}" max="${extent.max}" step="${step}" value="${escapeAttr(curMin)}" aria-label="${escapeAttr(t.min)}"/>
                <input type="range" data-cf-rs-max min="${extent.min}" max="${extent.max}" step="${step}" value="${escapeAttr(curMax)}" aria-label="${escapeAttr(t.max)}"/>
              </div>
            </div>
            <div class="custom-filters__price-range">
              <label class="custom-filters__price-field">
                <input type="number" data-cf-rs-min-inner min="${extent.min}" max="${extent.max}" step="${step}" placeholder="${escapeAttr(extent.min)}" value="${escapeAttr(curMin)}" aria-label="${escapeAttr(t.min)}"/>
              </label>
              <span class="custom-filters__price-sep" aria-hidden="true">–</span>
              <label class="custom-filters__price-field">
                <input type="number" data-cf-rs-max-inner min="${extent.min}" max="${extent.max}" step="${step}" placeholder="${escapeAttr(extent.max)}" value="${escapeAttr(curMax)}" aria-label="${escapeAttr(t.max)}"/>
              </label>
            </div>
          </div>
        </details>`;
      }
      // LISTAS LARGAS. Medido sobre el indice vivo: product_brand tiene 53 valores
      // distintos, sub_category 51, product_category 50 y color 30. Se pintaban todos
      // siempre, asi que en movil la faceta de marca ocupaba varias pantallas y empujaba
      // al resto fuera de la vista. Ver [Filtros 75] y [Filtros 76].
      const TOPE_VALORES_VISIBLES = 8;
      const VALORES_PARA_BUSCADOR = 15;

      // Las facetas que el cliente ya ha desplegado con «+N». Sin esto, marcar un valor
      // repinta el panel y la lista volveria a encogerse a 8 en mitad de la eleccion, que
      // es justo cuando el cliente esta comparando y mas molesta. Es el mismo motivo por
      // el que existe captureFacetOpenState para abrir y cerrar grupos.
      const facetasDesplegadas = new Set();

      function renderFacets() {
        if (!facetsEls.length) return;
        captureFacetOpenState();
        const resetLabel = t.reset || 'Reset';
        const extent = priceExtent();
        const curMin = state.priceMin != null ? state.priceMin : extent.min;
        const curMax = state.priceMax != null ? state.priceMax : extent.max;
        const priceActive = state.priceMin != null || state.priceMax != null;
        const caret = facetCaretSvg();

        const todosLosConteos = conteosDelRender; // calculados una vez por render en renderAhora

        const facetBlocks = state.facetKeys
          .filter((key) => !ASIDE_HIDDEN_KEYS.has(key))
          .map((key) => {
            // EL CORTE POR COBERTURA VA ANTES DE SEPARAR SLIDER DE LISTA. Un slider en
            // una coleccion que la faceta apenas conoce es PEOR que una lista de casillas:
            // al mover el mando desaparece en silencio todo el producto que no trae el
            // dato, y no hay ningun recuento delante que lo delate.
            // Medido el 28-sep-2026, cuando este corte estaba mas abajo y no las tocaba:
            //   number_of_burners               slider en 108 de sus 158 colecciones
            //                                   (5 de 157 productos en clearance-sale)
            //   wash_cycles                     85 de 148
            //   number_of_temperature_settings  81 de 128
            //   class_width                     solo 8 de 258, esa estaba bien
            //
            // La faceta se conserva si ya esta en uso, y para un slider eso NO es
            // state.selected sino state.range: sin mirar los dos, mover el mando haria
            // desaparecer el propio slider con el filtro puesto y sin forma de quitarlo.
            const enUso =
              (state.selected[key] || []).length > 0 || rangeIsActive(state.range[key]);
            if (coberturaEnColeccion(key) < TOPE_COBERTURA_FACETA && !enUso) return '';

            const rangeMeta = facetRangeMeta(state.facetMeta, key);
            if (rangeMeta) return rangeFacetBlock(key, rangeMeta, resetLabel, caret);
            if (!enUso && !facetaDistingue(key)) return '';
            const counts = todosLosConteos[key] || {};
            let values = Object.keys(counts).filter((v) => counts[v] > 0);
            if (key === 'vendor') {
              values = values.filter(
                (v) =>
                  !isExcludedVendor(v, cfg.excludedVendors) || (state.selected.vendor || []).includes(v),
              );
            }
            const useRange = shouldUseRangeSort(state.facetMeta, key, values);
            values.sort((a, b) => compareFacetValues(state.facetMeta, key, a, b, useRange));
            const selected = state.selected[key] || [];
            // Una faceta con un solo valor no filtra nada: TODOS los productos que quedan
            // lo tienen, asi que marcarla no cambia el resultado. Ocupaba sitio y el cliente
            // la abria para nada. Medido el 28-sep sobre las 247 colecciones con 12 o mas
            // productos: product_category salia asi en 79, convection en 57, sub_category en
            // 35, features_hard_food en 33.
            //
            // Se conserva si ya hay algo marcado: si no, al filtrar hasta dejar un unico
            // valor la faceta desapareceria con el filtro puesto y no habria como quitarlo.
            if (values.length < 2 && !selected.length) return '';

            let sobran = 0;
            const options = values
              .map((v, idx) => {
                const checked = selected.includes(v) ? 'checked' : '';
                const shown = displayValue(state.facetMeta, key, v);
                const id = `cf-${escapeAttr(key)}-${idx}`;
                // LO QUE YA ESTA MARCADO NUNCA SE ESCONDE, aunque caiga por debajo del
                // tope: si no, al volver a abrir la faceta pareceria que se ha
                // desmarcado solo, y el cliente no tendria como quitarlo.
                const extra =
                  idx >= TOPE_VALORES_VISIBLES && !checked && !facetasDesplegadas.has(key);
                if (extra) sobran += 1;
                // El texto se repite en data-cf-buscable para que el buscador de la
                // faceta no tenga que leer el DOM de dentro de la etiqueta.
                return `<label class="custom-filters__option${checked ? ' is-checked' : ''}${extra ? ' is-cf-extra' : ''}" for="${id}" data-cf-buscable="${escapeAttr(sinAcentos(shown).toLowerCase())}">
                  <input id="${id}" type="checkbox" class="input-checkbox input-filter-checkbox custom-filters__checkbox" data-cf-facet="${escapeAttr(key)}" value="${escapeAttr(v)}" ${checked}/>
                  <span class="custom-filters__option-label">${escapeHtml(shown)} (${counts[v] || 0})</span>
                </label>`;
              })
              .join('');
            const buscador =
              values.length >= VALORES_PARA_BUSCADOR
                ? `<input type="search" class="custom-filters__facet-search" data-cf-facet-search="${escapeAttr(key)}" placeholder="${escapeAttr(t.filter || 'Filter')}\u2026" aria-label="${escapeAttr(displayLabel(state.facetMeta, key))}"/>`
                : '';
            const verMas = sobran
              ? `<button type="button" class="custom-filters__more" data-cf-more="${escapeAttr(key)}" aria-expanded="false">+ ${sobran}</button>`
              : '';
            const tools = `<div class="custom-filters__group-tools">
              <span class="custom-filters__selected-count">${selected.length} ${escapeHtml(t.selected || 'selected')}</span>
              <button type="button" class="custom-filters__facet-reset" data-cf-facet-reset="${escapeAttr(key)}">${escapeHtml(resetLabel)}</button>
            </div>`;
            return `<details class="custom-filters__group${selected.length ? ' has-active' : ''}" data-cf-group="${escapeAttr(key)}"${groupOpenAttr(key)}>
              <summary>
                <span class="custom-filters__group-title">${escapeHtml(displayLabel(state.facetMeta, key))}</span>
                <span class="custom-filters__group-caret" aria-hidden="true">${caret}</span>
              </summary>
              <div class="custom-filters__group-body">${tools}${buscador}<div class="custom-filters__options">${options}</div>${verMas}</div>
            </details>`;
          })
          .join('');
  
        const priceTools = `<div class="custom-filters__group-tools custom-filters__group-tools--end">
          <button type="button" class="custom-filters__facet-reset" data-cf-facet-reset="__price">${escapeHtml(resetLabel)}</button>
        </div>`;
  
        const priceBlock = `<details class="custom-filters__group${priceActive ? ' has-active' : ''}" data-cf-group="__price"${groupOpenAttr('__price')}>
          <summary>
            <span class="custom-filters__group-title">${escapeHtml(t.price)}</span>
            <span class="custom-filters__group-caret" aria-hidden="true">${caret}</span>
          </summary>
          <div class="custom-filters__group-body">
            ${priceTools}
            <div class="custom-filters__price-slider" data-cf-price-slider data-min="${extent.min}" data-max="${extent.max}">
              <div class="custom-filters__price-track">
                <div class="custom-filters__price-progress" data-cf-price-progress></div>
              </div>
              <div class="custom-filters__price-ranges">
                <input type="range" data-cf-range-min min="${extent.min}" max="${extent.max}" step="1" value="${escapeAttr(curMin)}" aria-label="${escapeAttr(t.min)}"/>
                <input type="range" data-cf-range-max min="${extent.min}" max="${extent.max}" step="1" value="${escapeAttr(curMax)}" aria-label="${escapeAttr(t.max)}"/>
              </div>
            </div>
            <div class="custom-filters__price-range">
              <label class="custom-filters__price-field">
                <span class="custom-filters__price-prefix">$</span>
                <input type="number" data-cf-price-min-inner min="${extent.min}" max="${extent.max}" step="1" placeholder="0" value="${escapeAttr(curMin)}" aria-label="${escapeAttr(t.min)}"/>
              </label>
              <span class="custom-filters__price-sep" aria-hidden="true">–</span>
              <label class="custom-filters__price-field">
                <span class="custom-filters__price-prefix">$</span>
                <input type="number" data-cf-price-max-inner min="${extent.min}" max="${extent.max}" step="1" placeholder="${escapeAttr(extent.max)}" value="${escapeAttr(curMax)}" aria-label="${escapeAttr(t.max)}"/>
              </label>
            </div>
          </div>
        </details>`;
  
        const stockBlock = `<div class="custom-filters__stock">
          <label class="custom-filters__stock-toggle">
            <input type="checkbox" class="sr-only" data-cf-instock-inner ${state.inStockOnly ? 'checked' : ''}/>
            <span class="custom-filters__switch" aria-hidden="true"></span>
            <span class="custom-filters__stock-label">${escapeHtml(t.inStock)}</span>
          </label>
        </div>`;
  
        const titleHtml = `<p class="custom-filters__aside-title">${escapeHtml(t.filter)}</p>`;
        facetsEls.forEach((el) => {
          const inDrawer = !!el.closest('[data-cf-drawer]');
          el.innerHTML = `${inDrawer ? '' : titleHtml}${stockBlock}${priceBlock}${facetBlocks}`;
          bindFacetControls(el);
        });
      }
  
      function conditionBadgeLabel(cond) {
        const norm = String(cond || '')
          .toLowerCase()
          .replace(/\s+/g, '');
        return (
          cfg.conditionLabels[norm] ||
          cfg.conditionLabels[norm.replace('-', '')] ||
          String(cond)
        );
      }
  
      const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      let gridRenderToken = 0;

      // CF25. El cache de tarjetas del tema era un Map en memoria: al entrar a un producto y
      // volver con el boton atras se perdia entero y se repetian las 24 peticiones de esa
      // pagina. Se persiste en sessionStorage, que es por pestana y no sobrevive al cierre,
      // que es justo el alcance que tiene sentido para HTML de tarjeta.
      //
      // Todo acceso va en try/catch: en ventana privada, con el almacenamiento bloqueado o con
      // la cuota llena, leer o escribir LANZA. La pagina tiene que funcionar igual si vuelve
      // vacio, asi que esto es solo un atajo, nunca una fuente de verdad.
      // [Filtros 70] La clave lleva la raiz del idioma ('/' o '/fr/'). Sin ella, quien veia la
      // coleccion en ingles y cambiaba a frances en la misma pestana recibia las tarjetas
      // inglesas de la cache: «Dishwasher 23 inch...» con el panel entero en frances.
      const CLAVE_CACHE_TARJETAS = `cf-cards:${shopRoot}${collectionHandle || 'all'}`;
      const TOPE_TARJETAS = 120;

      function leerCacheTarjetas() {
        try {
          const crudo = sessionStorage.getItem(CLAVE_CACHE_TARJETAS);
          if (!crudo) return new Map();
          return new Map(Object.entries(JSON.parse(crudo)));
        } catch (e) {
          return new Map();
        }
      }

      const cardCache = leerCacheTarjetas();
      let guardadoPendiente = 0;

      function guardarCacheTarjetas() {
        if (guardadoPendiente) return;
        guardadoPendiente = setTimeout(() => {
          guardadoPendiente = 0;
          try {
            // Se guardan las ultimas: un Map conserva el orden de insercion.
            const entradas = [...cardCache.entries()].slice(-TOPE_TARJETAS);
            sessionStorage.setItem(CLAVE_CACHE_TARJETAS, JSON.stringify(Object.fromEntries(entradas)));
          } catch (e) {
            // Cuota llena o almacenamiento bloqueado: se abandona el atajo sin ruido.
            try {
              sessionStorage.removeItem(CLAVE_CACHE_TARJETAS);
            } catch (e2) {
              /* nada que hacer */
            }
          }
        }, 500);
      }
  
      function indexCardHtml(p) {
        // Fast placeholder from JSON index while theme cards load (no skeleton / loading-bar).
        const url = p.url || `${shopRoot}products/${p.handle}`;
        const vendor =
          showVendor && p.vendor ? `<p class="custom-filters__vendor">${escapeHtml(p.vendor)}</p>` : '';
        const condNorm = String(p.condition || '')
          .toLowerCase()
          .replace(/\s+/g, '');
        const condMod =
          condNorm.includes('neuf') ? 'neuf' : condNorm.includes('telquel') || condNorm.includes('tel-quel') ? 'telquel' : 'other';
        const cond = p.condition
          ? `<span class="custom-filters__badge custom-filters__badge--${condMod}">${escapeHtml(conditionBadgeLabel(p.condition))}</span>`
          : '';
        const img = p.image
          ? `<img class="custom-filters__img" src="${escapeAttr(p.image)}" alt="${escapeAttr(p.title || '')}" loading="lazy" width="400" height="400"/>`
          : '<div class="custom-filters__img-ph"></div>';
        const compareAt = Number(p.compareAt != null ? p.compareAt : p.compare_at);
        const price = Number(p.price);
        // [Taxes 2] Aqui NO se pinta la etiqueta. Esta tarjeta es la primera pasada, hecha
        // desde el indice, y el indice no trae las etiquetas del producto, asi que no se
        // puede saber si lleva una de las excluidas -forno_neuf y compania-. Pintarla a
        // ciegas la ensenaria en productos que no entran y habria que quitarla al llegar la
        // tarjeta del servidor. Mejor que aparezca un poco mas tarde que que aparezca mal.
        let priceHtml = `<p class="custom-filters__price">${formatMoney(price)}</p>`;
        if (!Number.isNaN(compareAt) && compareAt > price) {
          const pct = Math.round(((compareAt - price) * 100) / compareAt);
          priceHtml = `<p class="custom-filters__price"><span class="custom-filters__price-sale">${formatMoney(price)}</span><span class="custom-filters__price-compare">${formatMoney(compareAt)}</span><span class="custom-filters__price-pct">-${pct}%</span></p>`;
        }
        return `<article class="custom-filters__card"><a class="custom-filters__card-link" href="${escapeAttr(url)}"><div class="custom-filters__media">${img}</div></a><div class="custom-filters__card-body">${cond}${vendor}<h3 class="custom-filters__title"><a href="${escapeAttr(url)}">${escapeHtml(p.title)}</a></h3>${priceHtml}</div></article>`;
      }
  
      async function mapPool(items, limit, fn) {
        const out = new Array(items.length);
        let cursor = 0;
        async function worker() {
          while (cursor < items.length) {
            const idx = cursor++;
            out[idx] = await fn(items[idx], idx);
          }
        }
        const n = Math.min(limit, items.length) || 1;
        await Promise.all(Array.from({ length: n }, () => worker()));
        return out;
      }
  
      async function fetchThemeCardHtml(p) {
        const handle = p.handle;
        if (!handle) return indexCardHtml(p);
        if (cardCache.has(handle)) return cardCache.get(handle);
        const url = `${shopRoot}products/${encodeURIComponent(handle)}?section_id=cf-product-card`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`card ${res.status}`);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('.shopify-section') || doc.body;
        const card = section.querySelector('[data-cf-product-card]') || section;
        const html = card.innerHTML;
        if (!html.includes('product-card__wrapper') || html.includes('product-card-skeleton')) {
          throw new Error('theme card empty');
        }
        cardCache.set(handle, html);
        return html;
      }
  
      async function renderGrid(list) {
        const token = ++gridRenderToken;
        // EL TOPE DE PAGINA VA AQUI porque es el unico sitio donde se sabe el total:
        // readUrl lee ?page= antes de filtrar, asi que alli no hay con que comparar.
        //
        // Sin esto, /collections/refrigerators?page=99 salia con «No products match
        // these filters» teniendo 575 productos, y ?page=2abc igual -Number('2abc') es
        // NaN, Math.max(1, NaN) sigue siendo NaN y slice(NaN, NaN) devuelve lista
        // vacia-. Importa porque el indice tiene menos productos que cuando Google
        // indexo las URL con ?page=N del grid antiguo, asi que hay enlaces vivos
        // apuntando a paginas que ya no existen.
        //
        // El camino del BOTON ya se acotaba con Math.min(pages, ...); faltaba el de la
        // URL. Se manda a la ultima pagina y no a la primera, que es lo que menos
        // sorprende a quien llega de una busqueda.
        const totalPaginas = Math.max(1, Math.ceil(list.length / perPage));
        if (!Number.isFinite(state.page) || state.page < 1) state.page = 1;
        if (state.page > totalPaginas) state.page = totalPaginas;
        const start = (state.page - 1) * perPage;
        const pageItems = list.slice(start, start + perPage);
        if (!pageItems.length) {
          const emptyMsg =
            mode === 'search' && searchQuery
              ? t.emptySearch.replace('{q}', escapeHtml(searchQuery))
              : t.empty;
          // Se busca EL filtro que mas producto devuelve al quitarlo y se ofrece quitar
          // ese. Solo se calcula cuando ya no hay NADA que ensenar, asi que el coste -una
          // pasada por el catalogo por filtro activo- se paga una vez, y justo en el unico
          // momento en que el cliente esta parado mirando una pagina vacia.
          //
          // Todo lo que entra en el marcado pasa por escapeHtml o escapeAttr: la etiqueta
          // sale de displayLabel/displayValue, o sea del indice, y no se confia en ella.
          let sugerencia = '';
          if (!list.length) {
            let mejor = null;
            for (const e of activeEntries()) {
              const n = contarSin(e);
              if (n > 0 && (!mejor || n > mejor.n)) mejor = { e, n };
            }
            if (mejor) {
              sugerencia =
                `<button type="button" class="custom-filters__empty-fix" data-cf-quitar="${escapeAttr(mejor.e.key)}" data-cf-quitar-valor="${escapeAttr(mejor.e.value)}">` +
                `${escapeHtml(t.removeFilter.replace('{f}', mejor.e.label).replace('{n}', String(mejor.n)))}</button>`;
            }
          }
          gridEl.innerHTML = `<p class="custom-filters__empty">${emptyMsg}</p>${sugerencia}`;
          return;
        }
  
        // 1) Instant paint (index or cache) — same feel as original CF JS
        gridEl.innerHTML = pageItems
          .map((p, i) => {
            const html =
              p.handle && cardCache.has(p.handle) ? cardCache.get(p.handle) : indexCardHtml(p);
            return `<div class="grid-item" data-product-id="${escapeAttr(p.id || '')}" data-cf-card-slot="${i}">${html}</div>`;
          })
          .join('');
  
        if (window.Alpine && typeof Alpine.initTree === 'function') {
          Alpine.initTree(gridEl);
        }
  
        // 2) Upgrade missing slots to Maximize product-card (Section Rendering)
        await mapPool(pageItems, 6, async (p, i) => {
          if (token !== gridRenderToken || !p.handle || cardCache.has(p.handle)) return;
          try {
            const html = await fetchThemeCardHtml(p);
            if (token !== gridRenderToken) return;
            const slot = gridEl.querySelector(`[data-cf-card-slot="${i}"]`);
            if (!slot) return;
            slot.innerHTML = html;
            if (window.Alpine && typeof Alpine.initTree === 'function') {
              Alpine.initTree(slot);
            }
          } catch (err) {
            console.warn('[custom-filters] theme card fallback', p.handle, err);
          }
        });

        guardarCacheTarjetas();
        precargarSiguientePagina(list, token);
      }

      // CF24. Cada cambio de pagina dispara hasta perPage peticiones
      // /products/<handle>?section_id=cf-product-card (pool de 6). Mientras el cliente mira la
      // pagina actual el navegador esta parado, asi que se aprovecha para traer las de la
      // siguiente y que pasar de pagina sea instantaneo.
      //
      // Con pool de 2 y solo en idle: esto es trabajo especulativo y no debe competir con lo
      // que el usuario ha pedido de verdad. El token corta la precarga si ya cambio de pagina.
      function precargarSiguientePagina(list, token) {
        const idle = window.requestIdleCallback;
        if (typeof idle !== 'function') return;
        const inicio = state.page * perPage;
        const siguientes = list
          .slice(inicio, inicio + perPage)
          .filter((p) => p.handle && !cardCache.has(p.handle));
        if (!siguientes.length) return;
        idle(
          () => {
            if (token !== gridRenderToken) return;
            mapPool(siguientes, 2, (p) =>
              token === gridRenderToken ? fetchThemeCardHtml(p).catch(() => {}) : null,
            ).then(guardarCacheTarjetas);
          },
          { timeout: 3000 },
        );
      }
  
      function renderPager(total) {
        const pages = Math.max(1, Math.ceil(total / perPage));
        if (pages <= 1) {
          pagerEl.innerHTML = '';
          return;
        }
        const windowSize = 5;
        let start = Math.max(1, state.page - Math.floor(windowSize / 2));
        let end = Math.min(pages, start + windowSize - 1);
        start = Math.max(1, end - windowSize + 1);
        const nums = [];
        for (let i = start; i <= end; i++) nums.push(i);

        // CF40. El paginador eran <button> sin destino: no existia una sola URL hacia la pagina
        // 2, asi que no se podia abrir en otra pestana, ni copiar, ni rastrear. Ahora son <a>
        // de verdad y el clic sigue resolviendose en el sitio.
        //
        // Se construye con nodos y textContent en vez de innerHTML: el href sale de
        // window.location, que lleva parametros que escribe el visitante.
        //
        // El CSS del tema usa selectores de clase (.custom-filters__page-btn), no de etiqueta,
        // asi que el aspecto no cambia. Los extremos deshabilitados siguen siendo <button>
        // porque :disabled no aplica a un enlace.
        const urlDePagina = (n) => {
          const u = new URL(window.location.href);
          if (n > 1) u.searchParams.set('page', String(n));
          else u.searchParams.delete('page');
          return `${u.pathname}${u.search}`;
        };

        const trozos = [];
        const enlace = (n, texto, actual) => {
          const a = document.createElement('a');
          a.className = 'custom-filters__page-btn' + (actual ? ' is-current' : '');
          a.href = urlDePagina(n);
          a.textContent = String(texto);
          a.setAttribute('data-cf-page', String(n));
          if (actual) a.setAttribute('aria-current', 'page');
          return a;
        };
        const extremo = (destino, texto, apagado) => {
          if (!apagado) return enlace(destino, texto, false);
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'custom-filters__page-btn';
          b.disabled = true;
          b.textContent = texto;
          return b;
        };

        trozos.push(extremo(state.page - 1, t.prev, state.page <= 1));
        for (const n of nums) trozos.push(enlace(n, n, n === state.page));
        trozos.push(extremo(state.page + 1, t.next, state.page >= pages));

        pagerEl.textContent = '';
        for (const nodo of trozos) pagerEl.appendChild(nodo);

        pagerEl.querySelectorAll('[data-cf-page]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            // Ctrl/cmd-clic, shift o boton central: que el navegador haga lo suyo y abra la
            // pestana. Es la razon de poner el enlace, no se le puede quitar por delante.
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
            e.preventDefault();
            state.page = Math.min(pages, Math.max(1, Number(btn.getAttribute('data-cf-page'))));
            render();
            pushUrl();
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      }
  
      // Agrupador de renders. Un clic en una casilla, un chip y el slider disparaban cada uno
      // un render completo; tres clics seguidos eran tres recorridos del catalogo y tres
      // reconstrucciones del panel. Se agrupan en el siguiente frame.
      // render() es el planificador para que lo aprovechen los nueve sitios que ya lo llamaban;
      // quien necesite pintar YA (la primera carga y el boton atras) llama a renderAhora().
      let renderPendiente = 0;

      // Para no repetir el evento de «sin resultados» en cada repintado del mismo estado.
      let huboVacio = false;

      function render() {
        if (renderPendiente) return;
        renderPendiente = requestAnimationFrame(() => {
          renderPendiente = 0;
          renderAhora();
        });
      }

      function renderAhora() {
        // Un unico recorrido del catalogo por render para TODOS los conteos: los de las facetas
        // de casilla del panel y los de las dos barras de arriba (marca y condicion). Antes el
        // panel hacia una pasada por faceta y la barra otra distinta, y encima sin filtros.
        // Las facetas de rango se saltan: su extremo lo calcula facetExtent, que es otro calculo.
        conteosDelRender = computeAllCounts([
          ...state.facetKeys.filter(
            (key) => !ASIDE_HIDDEN_KEYS.has(key) && !facetRangeMeta(state.facetMeta, key),
          ),
          'vendor',
          'condition',
        ]);

        const list = filtered();
        const activeFilterCount = activeEntries().length;
        // La senal mas valiosa de todas: el cliente se ha quedado sin nada. Se manda UNA
        // vez por entrada en ese estado y no en cada repintado, porque si no un solo
        // callejon sin salida contaria varias veces y abultaria la estadistica.
        // Tambien una BUSQUEDA que no encuentra nada, aunque no haya filtros marcados: antes
        // solo se media con filtros, y la busqueda vacia, que es la que dice que sinonimo
        // falta, no llegaba nunca a GA4 ([Filtros 91]).
        if (!list.length && (activeFilterCount > 0 || (mode === 'search' && searchQuery))) {
          if (!huboVacio) {
            huboVacio = true;
            medir('cf_sin_resultados', {
              cf_filtros: activeFilterCount,
              cf_busqueda: (searchQuery || '').slice(0, 80),
            });
          }
        } else {
          huboVacio = false;
        }
        // Si se corrigio una falta, se dice que se ha buscado y lo que se tecleo.
        const corregida = mode === 'search' && searchQuery && busqueda().cambios.length > 0;
        // Se ensena lo que se tecleo cambiando solo las palabras corregidas, y en mayusculas
        // si se escribieron asi (un modelo): «LRFXS3016S» -> «LRFXS3106S», no «lrfxs3106s».
        const consultaMostrada = corregida
          ? searchQuery
              .split(/\s+/)
              .map((w) => {
                const c = busqueda().cambios.find(([de]) => de === sinAcentos(w).toLowerCase());
                if (!c) return w;
                return w === w.toUpperCase() ? c[1].toUpperCase() : c[1];
              })
              .join(' ')
          : searchQuery;
        if (statusEl) {
          const prefix =
            mode === 'search' && searchQuery ? t.resultsFor.replace('{q}', consultaMostrada) : '';
          statusEl.textContent =
            `${prefix}${list.length} ${plural(list.length, t.products)}` +
            (corregida ? ` · ${t.typed.replace('{q}', searchQuery)}` : '') +
            (activeFilterCount
              ? ` · ${activeFilterCount} ${plural(activeFilterCount, t.filters)}`
              : '');
        }
        if (mode === 'search' && searchQuery) {
          document.title =
            `${t.resultsFor.replace('{q}', consultaMostrada)}${list.length} ${plural(list.length, t.products)}` +
            (nombreTienda ? ` – ${nombreTienda}` : '');
        }
        [clearBtn, clearBtnMobile].forEach((btn) => {
          if (btn) btn.hidden = activeFilterCount === 0;
        });
        if (sortEl && sortEl.value !== state.sort) sortEl.value = state.sort;
        renderAdvanced();
        renderFacets();
        renderChips();
        renderGrid(list);
        renderPager(list.length);
      }
  
      // reemplazar=true solo para la normalizacion inicial de la URL (depurarSeleccion), que no
      // es una accion del usuario y no debe dejar entrada en el historial.
      function pushUrl(reemplazar) {
        if (state.syncingUrl) return;
        const url = new URL(window.location.href);
        const params = url.searchParams;
        [...params.keys()].forEach((k) => {
          if (k.startsWith('cf_') || k === 'page' || k === 'sort') params.delete(k);
        });
        if (state.sort && state.sort !== 'featured') params.set('sort', state.sort);
        if (state.page > 1) params.set('page', String(state.page));
        if (state.inStockOnly) params.set('cf_instock', '1');
        if (state.priceMin != null) params.set('cf_price_min', String(state.priceMin));
        if (state.priceMax != null) params.set('cf_price_max', String(state.priceMax));
        for (const [key, r] of Object.entries(state.range)) {
          if (!rangeIsActive(r)) continue;
          if (r.min != null) params.set(`cf_${key}_min`, String(r.min));
          if (r.max != null) params.set(`cf_${key}_max`, String(r.max));
        }
        for (const [key, values] of Object.entries(state.selected)) {
          if (values && values.length) params.set(`cf_${key}`, values.join(','));
        }
        const next = `${url.pathname}?${params.toString()}`.replace(/\?$/, '');

        // Nada que anotar si la URL no cambia: evita entradas de historial duplicadas cuando
        // un control hace commit sin haber movido nada.
        const actual = `${window.location.pathname}${window.location.search}`;
        if (next === actual) return;

        // ANTES ERA SIEMPRE replaceState, y por eso el manejador de popstate que hay mas abajo
        // no se disparaba nunca: el cliente aplicaba cuatro filtros, pulsaba atras y SALIA de la
        // coleccion en vez de deshacer el ultimo. Es el gesto mas comun en movil.
        if (reemplazar) window.history.replaceState({ cf: true }, '', next);
        else window.history.pushState({ cf: true }, '', next);
      }
  
      function readUrl() {
        const params = new URLSearchParams(window.location.search);
        state.sort = params.get('sort') || 'featured';
        state.page = Math.max(1, Number(params.get('page') || 1));
        state.inStockOnly = params.get('cf_instock') === '1';
        const pmin = params.get('cf_price_min');
        const pmax = params.get('cf_price_max');
        state.priceMin = pmin != null && pmin !== '' ? Number(pmin) : null;
        state.priceMax = pmax != null && pmax !== '' ? Number(pmax) : null;
        state.selected = {};
        state.range = {};
        params.forEach((value, key) => {
          if (!key.startsWith('cf_') || key === 'cf_instock' || key === 'cf_price_min' || key === 'cf_price_max') {
            return;
          }
          // cf_<faceta>_min / cf_<faceta>_max son extremos de rango, no una seleccion.
          // Se reconocen por el sufijo y no por metadatos: readUrl corre antes de que el
          // indice este cargado, asi que aqui todavia no se sabe que facetas son de rango.
          const bound = key.match(/^cf_(.+)_(min|max)$/);
          if (bound) {
            const n = value !== '' ? Number(value) : NaN;
            if (Number.isFinite(n)) {
              const rk = bound[1];
              const cur = state.range[rk] || { min: null, max: null };
              cur[bound[2]] = n;
              state.range[rk] = cur;
            }
            return;
          }
          const facetKey = key.slice(3);
          state.selected[facetKey] = value.split(',').filter(Boolean);
        });
      }
  
      // El panel de filtros en movil solo alternaba el atributo hidden: no se cerraba con
      // Escape, el foco no entraba dentro y al cerrar no volvia al boton. Quien navega con
      // teclado o lector abria los filtros y se quedaba tabulando por la rejilla de debajo.
      let focoAntesDelDrawer = null;

      const FOCUSABLES =
        'a[href], button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

      function focusablesDelDrawer() {
        return [...drawerEl.querySelectorAll(FOCUSABLES)].filter(
          (el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length,
        );
      }

      function teclasDelDrawer(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeDrawer();
          return;
        }
        if (e.key !== 'Tab') return;
        // Atrapar el tab dentro mientras esta abierto: si no, el foco se va a la pagina de
        // debajo, que para el usuario esta tapada.
        const lista = focusablesDelDrawer();
        if (!lista.length) return;
        const primero = lista[0];
        const ultimo = lista[lista.length - 1];
        if (e.shiftKey && document.activeElement === primero) {
          e.preventDefault();
          ultimo.focus();
        } else if (!e.shiftKey && document.activeElement === ultimo) {
          e.preventDefault();
          primero.focus();
        }
      }

      function openDrawer() {
        if (!drawerEl) return;
        focoAntesDelDrawer = document.activeElement;
        drawerEl.hidden = false;
        drawerEl.setAttribute('role', 'dialog');
        drawerEl.setAttribute('aria-modal', 'true');
        document.documentElement.classList.add('custom-filters-drawer-open');
        const lista = focusablesDelDrawer();
        if (lista.length) lista[0].focus();
        document.addEventListener('keydown', teclasDelDrawer);
      }

      function closeDrawer() {
        if (!drawerEl) return;
        drawerEl.hidden = true;
        document.documentElement.classList.remove('custom-filters-drawer-open');
        document.removeEventListener('keydown', teclasDelDrawer);
        if (focoAntesDelDrawer && typeof focoAntesDelDrawer.focus === 'function') {
          focoAntesDelDrawer.focus();
        }
        focoAntesDelDrawer = null;
      }
  
      if (clearBtn) clearBtn.addEventListener('click', clearAll);
      if (clearBtnMobile) clearBtnMobile.addEventListener('click', clearAll);
      if (sortEl) {
        sortEl.addEventListener('change', () => {
          state.sort = sortEl.value;
          state.page = 1;
          render();
          pushUrl();
        });
      }
      if (filterToggleBtn) {
        filterToggleBtn.addEventListener('click', () => {
          // Mobile: open drawer. Desktop: toggle aside (shown by default).
          if (window.matchMedia('(max-width: 899px)').matches) {
            openDrawer();
            return;
          }
          asideFiltersVisible = !asideFiltersVisible;
          root.classList.toggle('custom-filters--aside-hidden', !asideFiltersVisible);
          filterToggleBtn.setAttribute('aria-pressed', String(asideFiltersVisible));
        });
      }
      drawerCloseBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));
      window.addEventListener('popstate', () => {
        state.syncingUrl = true;
        readUrl();
        renderAhora(); // sincrono: syncingUrl tiene que seguir activo mientras se pinta
        state.syncingUrl = false;
      });
  
      if (statusEl) statusEl.textContent = t.loading;

      // LA REJILLA SE QUEDA QUIETA AL TERMINAR, y el panel de filtros sigue bajando.
      //
      // Aqui NO se decide nada: la cuenta entera vive en el CSS, en la regla de
      // .custom-filters__main--pegada, que explica el porque. Lo unico que el CSS no
      // puede saber es cuanto mide la rejilla, asi que es lo unico que se publica.
      //
      // NO HAY LISTENER DE SCROLL NI DE RESIZE. El efecto lo hace position:sticky del
      // navegador, y el 100vh de la formula ya reacciona solo al cambiar la ventana. La
      // altura se lee de la propia entrada del observer y no con offsetHeight, para no
      // forzar un recalculo de maquetacion en cada cambio.
      function aplicarPegado(mainEl) {
        let altoPublicado = null;
        const observador = new ResizeObserver((entradas) => {
          for (const entrada of entradas) {
            const caja = entrada.borderBoxSize && entrada.borderBoxSize[0];
            const alto = Math.round(
              caja ? caja.blockSize : entrada.contentRect.height,
            );
            // Escribir solo cuando cambia de verdad: asi esto no puede realimentarse.
            if (!alto || alto === altoPublicado) continue;
            altoPublicado = alto;
            mainEl.style.setProperty('--cf-main-h', alto + 'px');
            mainEl.classList.add('custom-filters__main--pegada');
          }
        });
        observador.observe(mainEl);
      }

      const mainEl = qs(root, '.custom-filters__main');
      if (mainEl && typeof ResizeObserver === 'function') aplicarPegado(mainEl);

      // CF28. readUrl corre antes de que el indice este cargado, asi que acepta cualquier
      // parametro cf_*. Una URL vieja, un bot o una faceta retirada de la allowlist metian una
      // clave inexistente en la seleccion, y como matchesFilters descarta al producto que no
      // tiene valor en una faceta seleccionada, la rejilla salia VACIA con un chip de nombre
      // inventado. Se depura en cuanto se sabe que facetas existen de verdad.
      function depurarSeleccion() {
        const conocidas = new Set([...state.facetMeta.byKey.keys(), ...ASIDE_HIDDEN_KEYS]);
        const descartadas = [];
        for (const key of Object.keys(state.selected)) {
          if (!conocidas.has(key)) {
            descartadas.push(key);
            delete state.selected[key];
          }
        }
        for (const key of Object.keys(state.range)) {
          if (!conocidas.has(key)) {
            descartadas.push(`${key} (rango)`);
            delete state.range[key];
          }
        }
        // UNA FACETA QUE ERA DE CASILLAS Y AHORA ES SLIDER deja enlaces viejos por ahi:
        // ?cf_dimensions_depth=Above%2026%20inch. La clave SIGUE existiendo, asi que el
        // bucle de arriba no la limpia, pero sus valores ya no son «Above 26 inch» sino
        // numeros, y ninguno casa. El resultado seria cero productos SIN DECIR POR QUE.
        // Una seleccion de casillas sobre una faceta de rango no significa nada: se tira.
        for (const key of Object.keys(state.selected)) {
          if (facetRangeMeta(state.facetMeta, key)) {
            descartadas.push(`${key} (era de casillas, ahora es slider)`);
            delete state.selected[key];
          }
        }
        if (descartadas.length) {
          console.warn('[custom-filters] filtros de la URL que no existen en el indice, se ignoran:', descartadas.join(', '));
          pushUrl(true); // normalizacion, no accion del usuario: sin entrada de historial
        }
      }

      // CF30 y CF31. Dos canarios baratos: el indice se refresca a mano (no hay cron), y el JS
      // del tema se cachea de forma agresiva, asi que puede haber navegadores sirviendo un JS
      // viejo contra un indice nuevo. Ninguno de los dos bloquea: avisan.
      function revisarIndice(data) {
        if (data.version != null && Number(data.version) !== SCHEMA_INDICE_SOPORTADO) {
          console.warn(
            `[custom-filters] el indice declara version ${data.version} y este JS entiende la ` +
              `${SCHEMA_INDICE_SOPORTADO}. Puede haber campos que no se lean.`,
          );
        }
        const generado = Date.parse(data.generatedAt || '');
        if (Number.isFinite(generado)) {
          const dias = Math.floor((Date.now() - generado) / 86400000);
          if (dias >= DIAS_INDICE_VIEJO) {
            console.warn(
              `[custom-filters] el indice se genero hace ${dias} dias (${data.generatedAt}). ` +
                'Precios y stock pueden estar desfasados: falta lanzar index/refresh.',
            );
          }
        }
      }

      function pintarIndice(data) {
        state.all = Array.isArray(data.products) ? data.products : [];
        // Antes de pintar y antes de que nadie busque: searchableText memoiza en p.__cfs.
        handlesGenericos = calcularHandlesGenericos(state.all);
        facetasBusqueda = (Array.isArray(data.facets) ? data.facets : []).filter(
          (f) => f && f.key && !FACETAS_FUERA_DE_BUSQUEDA.has(f.key)
        );
        baseCache = null; // unico punto que mueve el catalogo base (ver baseList)
        busquedaCache = null; // la correccion de faltas depende del catalogo
        vocabulario = null;
        coberturaCache = null; // depende del catalogo base, se tira con el
        distingueCache = null; // idem
        state.facetMeta = buildFacetMeta(data);
        state.facetKeys = applyFacetOrderRules(
          state.facetMeta,
          state.facetMeta.orderedKeys,
          collectionHandle,
          cfg.priorityRules,
          cfg.hiddenRules,
        );
        revisarIndice(data);
        readUrl();
        depurarSeleccion();
        renderAhora(); // primera pintada: sin esperar al frame siguiente
      }

      // El fetch ya salio al parsear el script (ver cargarIndice / precargarIndices abajo):
      // aqui solo se recoge. Si por lo que sea no hubiera precarga, se pide ahora.
      (indicesEnVuelo.get(indexUrl) || cargarIndice(indexUrl))
        .then(pintarIndice)
        .catch((err) => {
          console.error('[custom-filters]', err);
          if (statusEl) statusEl.textContent = t.indexError;
        });
    }
  
    // CF29. Sin esto, un 503 de un instante en el CDN deja la coleccion SIN UN SOLO PRODUCTO y
    // con un mensaje tecnico en ingles: el motor custom es el unico que pinta la rejilla, no hay
    // degradacion a Search & Discovery. Un reintento corto y, si el archivo del locale sigue sin
    // venir, el espejo EN, que es mejor que nada.
    function espejoDe(url) {
      const espejo = String(url).replace(/-index\.(en|fr)\.json/, '-index.json');
      return espejo !== String(url) ? espejo : null;
    }

    function pedirIndice(url) {
      return fetch(url, { credentials: 'omit' }).then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json().then(expandirColecciones);
      });
    }

    // [Filtros 73] El backend manda en `collections` posiciones de la tabla `collectionHandles`
    // en vez de los handles: eran el 38 % del indice. Aqui se devuelven a handles una sola vez,
    // antes de que nadie los lea. Un indice viejo, con handles, pasa tal cual: los dos formatos
    // valen, y por eso este tema se puede publicar antes que el backend.
    // [Filtros 105] El indice tampoco trae `url` (sale del handle en indexCardHtml) y quita el
    // principio comun de las imagenes, que viene una sola vez en `imagePrefix`. Se vuelve a
    // pegar aqui. Una imagen que ya es absoluta (indice viejo) no se toca.
    function expandirColecciones(data) {
      const tabla = data && Array.isArray(data.collectionHandles) ? data.collectionHandles : null;
      const prefijo = data && typeof data.imagePrefix === 'string' ? data.imagePrefix : '';
      if (!tabla && !prefijo) return data;
      for (const p of data.products || []) {
        if (tabla && Array.isArray(p.collections)) {
          p.collections = p.collections.map((c) => (typeof c === 'number' ? tabla[c] : c));
        }
        if (prefijo && typeof p.image === 'string' && p.image && !/^(https?:)?\/\//.test(p.image)) {
          p.image = prefijo + p.image;
        }
      }
      return data;
    }

    function cargarIndice(url) {
      return pedirIndice(url)
        .catch((err) => {
          console.warn('[custom-filters] fallo la carga del indice, reintentando:', err.message);
          return new Promise((r) => setTimeout(r, 600)).then(() => pedirIndice(url));
        })
        .catch((err) => {
          const espejo = espejoDe(url);
          if (!espejo) throw err;
          console.warn('[custom-filters] segundo fallo, se prueba el espejo EN:', espejo);
          return pedirIndice(espejo);
        });
    }

    // CF23. El indice son ~229 KB comprimidos y su fetch esperaba a DOMContentLoaded, dentro de
    // init(). Se lanza al parsear el script: la URL vive en un data-attribute, asi que basta con
    // que el elemento ya este en el DOM, que es el caso con el script al final del body o con
    // defer. Si no lo estuviera, init() lo pide igual y no se pierde nada.
    const indicesEnVuelo = new Map();

    function precargarIndices() {
      document.querySelectorAll('[data-custom-filters]').forEach((el) => {
        const url = el.dataset.indexUrl;
        if (!url || indicesEnVuelo.has(url)) return;
        const promesa = cargarIndice(url);
        // Sin este catch, un fallo antes de que init() se enganche cuenta como rechazo no
        // manejado y ensucia la consola con un error que si esta tratado.
        promesa.catch(() => {});
        indicesEnVuelo.set(url, promesa);
      });
    }

    precargarIndices();

    function boot() {
      document.querySelectorAll('[data-custom-filters]').forEach(init);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  